import React, { useState } from 'react';
import { SPLeadModel, LeadAdditionModel, LeadAdditionRelationModel, LeadModel, SelectListItem, VehicleDataModel, User, CustomerAddress, DynamicObject1, Manufacturer, VehicleSubModel, Vehicle, VehicleSubModelModel } from '../models/superbit-api-models'
import '../assets/css/_new-lead-popup.css'
import { Lead } from './_Lead';
import { DynamicSelect } from '../components/_DynamicSelect'
import { IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData } from '../models/Site'
import { SimulatorModel, SimulatorData } from '../models/SimulatorModel'
// import Select, { components, DropdownIndicatorProps } from 'react-select';
import { MultiSelectionSelect } from '../components/_MultiSelectionSelect';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect'
import { LeadsModel } from '../models/LeadsModel';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Address } from '../Adrress/_Address';
import { Autocomplete } from '../components/_Autocomplete';
import SignaturePad from "react-signature-canvas";
import generalSettings from '../json/general-settings.json';

import { Select, TreeSelect } from 'antd';
import moment from 'moment';
import VehicleDetails from "../vehicles/_VehicleDetails"
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { GeneralDataModel } from '../models/GeneralDataModel';
import AddContactDetails from './_AddContactDetails';

import VehicleData from "../vehicles/_Vehicle";
import { RootState } from '../app-context/store';
import { connect } from 'react-redux';
import { setLeadStore, setSimulatorData } from '../app-context/policyProduction';
import { OfferProductionModel } from '../models/OfferProductionModel';
import { setCallerTreatment, setPhoneNumberForCreateLead } from '../app-context/caller';
import { CustomerCardModel } from '../models/CustomerCardModel';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';

const { TreeNode } = TreeSelect;

interface PolicyTypes {
    [key: number]: any;
}

type Props = {
    id: string | null;
    ClosePopup: any;
    leadData: LeadModel | null;
    treeData: any[];
    leadStore?: any;
    simulatorData?: any;
    setLeadStore: (obj: any | null) => void;
    setSimulatorData: (obj: any | null) => void;
    treeDataBrunches: any[];
    phoneNumberForCreateLead: string;
    setPhoneNumberForCreateLead: (phoneNumber: string) => void;
    callerTreatment: any;
    setCallerTreatment: (treatment: any) => void;
};
type State = {
    Lead: any | null;
    SourceLead: any | null;
    InsuranceTypes: IDNameDescriptionDictionary;
    PropertyType: IDNameDescriptionDictionary;
    InsuranceType: IDNameDescriptionDictionary;
    policyTypes: IDNameDescriptionDictionary;
    IdentityTypes: IDNameDescriptionDictionary;
    Statuses: IDNameDescriptionDictionary;
    AuthorizedToDrive: IDNameDescriptionDictionary;
    Geder: IDNameDescriptionDictionary;
    MaritalStatus: IDNameDescriptionDictionary;
    PassedTypeOfInsurance: IDNameDescriptionDictionary;
    VehicleOwnership: IDNameDescriptionDictionary;
    ImpairmentDeductible: IDNameDescriptionDictionary;
    RenovationAgentsOffice: IDNameDescriptionDictionary;
    RenovationCompany: IDNameDescriptionDictionary;
    CarYear: Array<string>;
    ModelcodeAutocomplete: Array<AutocompleteData>,
    ModelcodeAll: Array<AutocompleteData>,
    ManufacturerAll: Array<AutocompleteData>
    ManufacturerAutocomplete: Array<AutocompleteData>
    VehicleModelAutocomplete: Array<AutocompleteData>
    VehicleModelAll: Array<AutocompleteData>
    VehicleSubModelAutocomplete: Array<AutocompleteData>
    VehicleSubModelAll: Array<AutocompleteData>;
    licenseNumber: string;
    CustomerAgents: IDNameDescriptionDictionary;
    CustomerHandlers: IDNameDescriptionDictionary;
    Branches: IDNameDescriptionDictionary;
    LeadTopType: number;
    licenseError: boolean;
    modelError: boolean;
    modelCodeNotExists: boolean;
    addressError: boolean;
    IgnoreSignature: boolean;
    SignatureCheckbox: boolean;
    carLicenseFile: {
        fileName: string | null;
        url: string | null
    } | null;
    licenseNumberLoading: boolean;
    modelCodeLoading: boolean;
    treeData: any[];
    initialSignatureUrl: string | null;
    customerErrors: any;
    signatureError: boolean;
    policyTypeError: boolean;
    signatureSelectError: boolean;
    propertyTypeError: boolean;
    identifierError: boolean;
    vehicleErrors: {
        year: boolean;
    }
    deliveryDateError: boolean;
    agentError: boolean;
    handlerError: boolean;
    errors: any;
    warnings: any;
    loggedUser: any | null;
    isAdmin: boolean;
    doubleLeadWarning: any;
    doubleLeadWarning1: any;
    doubleLeadWarning2: any;
    apiUrl: string | null;
    leadAdditionsFromRelation: any;
    missingVehicleDetails: boolean;
    showVehicleDetails: boolean;
    ShowVehiclePopup: boolean;
    Vehicle: VehicleDetailsData | null;
    lastLicense: string;
    lastmodelCode: string;
    moreDetailsPermission: boolean;
    contactNumber: number;
    CustomerHandlersList: IDNameDescriptionDictionary;
    saveLoading: boolean;
    position: any;
    isDragging: boolean;
    offset: any;
    loading: boolean;
};

class VehicleDetailsData {
    tozeretCd?: number;
    degemCd?: number;
    manufacturerId?: string;
    vehicleModelId?: string;
    vehicleSubModelId?: string;
    modelCode?: string;
    carYear?: number;
};

class LeadPopup extends React.Component<Props> {
    private deliveryDateRef: React.RefObject<DatePicker>;
    private identifierDateRef: React.RefObject<DatePicker>;
    private simulatorModel: SimulatorModel;
    private canvasRef: React.RefObject<any>;
    private hiddenFileInput: React.RefObject<any>;
    // Survives StrictMode's double load() - the redux value is cleared on first
    // consumption, so a second run must reuse it from here instead of redux.
    private pendingPhoneNumberForCreateLead: string = '';
    // private canvasRef = React.useRef(null);

    state: State = {
        Lead: null,
        SourceLead: null,
        InsuranceTypes: new IDNameDescriptionDictionary(),
        PropertyType: new IDNameDescriptionDictionary(),
        InsuranceType: new IDNameDescriptionDictionary(),
        policyTypes: new IDNameDescriptionDictionary(),
        IdentityTypes: new IDNameDescriptionDictionary(),
        Statuses: new IDNameDescriptionDictionary(),
        AuthorizedToDrive: new IDNameDescriptionDictionary(),
        Geder: new IDNameDescriptionDictionary(),
        PassedTypeOfInsurance: new IDNameDescriptionDictionary(),
        MaritalStatus: new IDNameDescriptionDictionary(),
        VehicleOwnership: new IDNameDescriptionDictionary(),
        ImpairmentDeductible: new IDNameDescriptionDictionary(),
        RenovationAgentsOffice: new IDNameDescriptionDictionary(),
        RenovationCompany: new IDNameDescriptionDictionary(),
        CarYear: [],
        ModelcodeAutocomplete: [],
        ModelcodeAll: [],
        ManufacturerAutocomplete: [],
        ManufacturerAll: [],
        VehicleModelAutocomplete: [],
        VehicleModelAll: [],
        VehicleSubModelAutocomplete: [],
        VehicleSubModelAll: [],
        licenseNumber: '',
        CustomerAgents: new IDNameDescriptionDictionary(),
        CustomerHandlers: new IDNameDescriptionDictionary(),
        Branches: new IDNameDescriptionDictionary(),
        LeadTopType: 0,
        licenseError: false,
        modelError: false,
        modelCodeNotExists: false,
        addressError: false,
        IgnoreSignature: false,
        SignatureCheckbox: false,
        carLicenseFile: null,
        licenseNumberLoading: false,
        modelCodeLoading: false,
        treeData: this.props.treeData,
        initialSignatureUrl: null,
        customerErrors: {
            firstName: false,
            lastName: false,
            firstName2: false,
            lastName2: false,
            firstName3: false,
            lastName3: false,
            phoneNumber1: false,
            phoneNumber2: false,
            phoneNumber12: false,
            phoneNumber22: false,
            phoneNumber13: false,
            phoneNumber23: false,
            email: false,
            identifier: false,
        },
        errors: {
            invalidMobilePhoneNumber: 'מס טלפון הנייד לא תקין',
            invalidPhoneNumber: 'מס טלפון לא תקין',
            requiredField: 'שדה חובה',
            modelCodeNotExists: 'קוד דגם לא קיים',
            requiredModelCodeOrLicenseNumber: 'חובה קוד דגם או מס\' רישוי',
            reguiredIdNineNumbers: 'ת.ז. חייב להכיל 9 ספרות',
            invalidId: 'מספר ת.ז. לא תקין',
            doubleLeadWarning: 'קיים ליד כפול',
            idIsExists: 'לקוח קיים במערכת, שונו פרטי לקוח'
        },
        warnings: {
            idIsExists: false
        },
        signatureError: false,
        policyTypeError: false,
        propertyTypeError: false,
        signatureSelectError: false,
        identifierError: false,
        vehicleErrors: {
            year: false
        },
        agentError: false,
        handlerError: false,
        deliveryDateError: false,
        loggedUser: {},
        isAdmin: false,
        doubleLeadWarning: {
            mobile: false,
            phone: false,
            license: false
        },
        doubleLeadWarning1: {
            mobile: false,
            phone: false,
            license: false
        },
        doubleLeadWarning2: {
            mobile: false,
            phone: false,
            license: false
        },
        apiUrl: localStorage.getItem('apiUrl'),
        leadAdditionsFromRelation: [],
        missingVehicleDetails: false,
        showVehicleDetails: false,
        ShowVehiclePopup: false,
        Vehicle: null,
        lastLicense: "",
        lastmodelCode: "",
        moreDetailsPermission: false,
        contactNumber: 1,
        CustomerHandlersList: new IDNameDescriptionDictionary(),
        saveLoading: false,
        position: { x: 500, y: 30 },
        isDragging: false,
        offset: { x: 0, y: 0 },
        loading: false
    };


    constructor(props: any) {
        super(props);
        // var lead = this.state.Lead;
        this.deliveryDateRef = React.createRef<DatePicker>();
        this.identifierDateRef = React.createRef<DatePicker>();
        this.canvasRef = React.createRef();
        this.hiddenFileInput = React.createRef();
        this.simulatorModel = new SimulatorModel();

        this.loadModelCode = this.loadModelCode.bind(this);


    }
    componentDidMount() {
        this.load();
        // localStorage.setItem('loggedUser'
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            this.setState({
                isAdmin: (loggedUser.role == 0 || loggedUser.role == 7)
            })

        }
        let moodelPermision = loggedUser.menuPermissions;

        if (loggedUser.role == 2 || loggedUser.role == 3 || loggedUser.role == 4 || loggedUser.role == 5 || loggedUser.role == 15) {
            this.setState({ moreDetailsPermission: false });
        } else {
            this.setState({ moreDetailsPermission: true });
        }
    }

    async load() {
        this.setState({loading:true});
        var CarYear = [];
        CarYear.push("");
        // set start year the current year, but if after 15 December, set next year
        let startYear = new Date().getFullYear();
        if(new Date().getMonth() == 11 && new Date().getDate() > 15){
            startYear = startYear + 1;
        }
        
        for (let i: number = new Date().getFullYear() + 1; i >= new Date().getFullYear() - 31; i--) {
            CarYear.push(i + "");
        }

        let propertyIndex = 0;
        const propertyTypeList: IDNameDescriptionDictionary = new IDNameDescriptionDictionary();
        propertyTypeList[propertyIndex] = {
            "id": -1,
            "name": "Select",
            "description": "בחר"
        };
        const propertyTypes = await this.simulatorModel.getPropertyType();
        propertyIndex++;
        Object.keys(propertyTypes).forEach(key => {
            propertyTypeList[propertyIndex] = propertyTypes[key];
            propertyIndex++;
        })

        

        console.log('settings.policyTypes', generalSettings.policyTypes)
        let policyList: any = generalSettings.policyTypes;
        console.log('policyList', policyList)

        if (policyList.hasOwnProperty(1) && policyList.hasOwnProperty(2) && policyList.hasOwnProperty(3)) {
            delete policyList[1];
            delete policyList[2];
            delete policyList[3];
        }
        
        const treeData = this.props.treeData;
        this.setState({
            InsuranceTypes: await this.simulatorModel.getInsuranceTypes(),
            PropertyType: propertyTypeList,
            InsuranceType: generalSettings.policyTypes,
            policyTypes: policyList,
            AuthorizedToDrive: await this.simulatorModel.getAuthorizedToDriveItems(),
            Geder: await this.simulatorModel.getGenderTypes(),
            PassedTypeOfInsurance: await this.simulatorModel.getPassedTypeOfInsurance(),
            MaritalStatus: await this.simulatorModel.getMaritalStatus(),
            VehicleOwnership: await this.simulatorModel.getVehicleOwnership(),
            ImpairmentDeductible: await this.simulatorModel.getImpairmentDeductible(),
            RenovationAgentsOffice: await this.simulatorModel.getRenovationAgentsOffice(),
            RenovationCompany: await this.simulatorModel.getRenovationCompany(),
            CarYear: CarYear,
            IdentityTypes: await this.simulatorModel.getIdentityTypes(),
            ManufacturerAll: await this.simulatorModel.getManufacturers(),
            treeData
        });
        let model = new LeadModel();

        if (this.props.id && this.props.id != "0") {
            // id = this.props.id;
            model = await new LeadsModel().getLeadForUpsert(this.props.id);
            console.log('load model', model)

            // model.IgnoreSignature=true;
            if (this.props.leadData) {
                this.setState({ SourceLead: this.props.leadData });
            }
            if (model.carLicenseFilePath && model.carLicenseFilePath !== '') {
                const fileName = model.carLicenseFilePath.substring(model.carLicenseFilePath.lastIndexOf('/') + 1);
                const carLicenseFile: any = {
                    fileName: fileName,
                    url: model.carLicenseFilePath
                }
                this.setState({
                    carLicenseFile: carLicenseFile
                })
            }
            this.setState({
                Lead: model,
                leadAdditions: model.leadAdditions ? model.leadAdditions : []
            });
        } else {
            // id = undefined;
            model = await new LeadsModel().getLeadForUpsert(undefined);
            console.log('load model', model)
            if (this.canvasRef.current) {
                const signatureUrl = this.canvasRef.current.getTrimmedCanvas().toDataURL("image/png");
                this.setState({
                    signatureUrl
                })
            }
            if (model.leadTopType == 0) {
                if (!model.vehicle) {
                    model.vehicle = new VehicleDataModel();
                }
                if (this.props.leadStore && this.props.leadStore.vehicle) {

                    model.vehicle.licenseNumber = this.props.leadStore.vehicle.licenseNumber;
                    model.vehicle.carYear = this.props.leadStore.vehicle.CarYear;
                    model.vehicle.modelCode = this.props.leadStore.vehicle.modelCode;
                } else {
                    model.vehicle.carYear = new Date().getMonth() == 11 && new Date().getDate() >= 15 ? parseInt(this.state.CarYear[1]) : parseInt(this.state.CarYear[2]);
                }

            }

        }
        if (!model.identityType || model.identityType < 1) {
            model.identityType = 1;
        }
        if (!model.deliveryDate) {
            model.deliveryDate = undefined;
            // if (model.leadTopType == 0) {
            //     model.deliveryDate = this.checkDate(model.createdDate);
            // } else {
            //     model.deliveryDate = undefined;
            // }
        } else {
            model.deliveryDate = this.checkDate(model.deliveryDate);
        }
        if (!model.identityCardIssueDate || (model.identityCardIssueDate < new Date('1974-01-01'))) {
            model.identityCardIssueDate = undefined;
            // if (model.leadTopType == 0) {
            //     model.deliveryDate = this.checkDate(model.createdDate);
            // } else {
            //     model.deliveryDate = undefined;
            // }
        } else {
            model.identityCardIssueDate = this.checkDate(model.identityCardIssueDate);
        }
        if (model.agents && model.agents.length > 0) {
            // const agentsList = await this.buildSelectDataObject(model.agents);
            const agentsList = this.buildSelectDataObjectAgentList(model.agents);

            this.setState({
                CustomerAgents: agentsList
            })
        } else {
            const agentsList = this.buildSelectDataObject([
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "אבישג סעדה ",
                    "value": "8f477c1a-dc6a-4e1b-cbe8-08d91f51c6ac"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "יותם שלמה",
                    "value": "7c589cc8-8e4f-4bac-ebf8-08d947918204"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "לילך מולכו",
                    "value": "b1a45886-0030-4ad0-8ad1-08d9d343c9a1"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "גיא פרידמן",
                    "value": "6cc397e6-287d-4486-e5ba-08da5aad0284"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "קרן לוי",
                    "value": "0be0a470-5fe9-44b8-c18d-08da6fc373a2"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "רויטל דדון",
                    "value": "acd64858-40e1-4179-85e3-08da790b664b"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "רבקה מכירות",
                    "value": "17d2625f-92ea-4794-eafd-08da8355b94a"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "מארי אזולאי",
                    "value": "ea3a5f0d-0e8a-49da-c237-08dab589b9fa"
                }
            ]);
            this.setState({
                CustomerAgents: agentsList
            })
        }


        // salesPeople
        let loggedUser: any = localStorage.getItem('loggedUser');
        loggedUser = JSON.parse(loggedUser);

        if (model.salesPeople && model.salesPeople.length > 0 ) {
            let salsePeopleList = model.salesPeople.filter((item: any) => item.status == 0 && item.fullName != null);
            let salesPeopleSorted = salsePeopleList.sort((a: any, b: any) => a.fullName.localeCompare(b.fullName));
            console.log('model.salesPeople', model.salesPeople)
            
            // const salesPeopleData = await this.buildSelectDataObject(salesPeopleSorted);
            const salesPeopleData = this.buildSelectDataObjectHandleList(salesPeopleSorted);
            salesPeopleData.unshift(
                {
                    description: "בחר",
                    name: "בחר",
                    id: "0",
                    agentId: "0"
                })

            const salesPeopleDataByAgent = salesPeopleData.filter((item: any) => item.agentId == model.agentId || item.agentId == "0");

            this.setState({
                CustomerHandlers: salesPeopleDataByAgent,
                CustomerHandlersList: salesPeopleData
            })
            console.log('CustomerHandlers model', model)

            if(model.handlerId){
                console.log('salesPeopleSorted', salesPeopleSorted)
                const selected = salesPeopleSorted.find((salesMan: any) =>  salesMan.id == model.handlerId && salesMan.status == 0);
                console.log('selected', selected)
                model.handlerId = selected ? selected.id : '';
                
            }
            
        } else {
            const salesPeople = this.buildSelectDataObject([
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "אבישג סעדה ",
                    "value": "8f477c1a-dc6a-4e1b-cbe8-08d91f51c6ac"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "יותם שלמה",
                    "value": "7c589cc8-8e4f-4bac-ebf8-08d947918204"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "לילך מולכו",
                    "value": "b1a45886-0030-4ad0-8ad1-08d9d343c9a1"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "גיא פרידמן",
                    "value": "6cc397e6-287d-4486-e5ba-08da5aad0284"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "קרן לוי",
                    "value": "0be0a470-5fe9-44b8-c18d-08da6fc373a2"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "רויטל דדון",
                    "value": "acd64858-40e1-4179-85e3-08da790b664b"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "רבקה מכירות",
                    "value": "17d2625f-92ea-4794-eafd-08da8355b94a"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "מארי אזולאי",
                    "value": "ea3a5f0d-0e8a-49da-c237-08dab589b9fa"
                }
            ]);
            this.setState({
                CustomerHandlers: salesPeople
            })
        }
        // statuses
        if (model.statuses && model.statuses.length > 0) {
            const statuses = await this.buildSelectDataObjectAgentList(model.statuses);
            this.setState({
                Statuses: statuses
            })
        } else {
            const statuses = this.buildSelectDataObject([
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "שיחה 1",
                    "value": "97c084bc-ee6d-486f-bc31-0eee7ea2104f"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "שיחה 2",
                    "value": "07f7a236-7101-4fa8-8670-2dad3bc06366"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "סגירה",
                    "value": "9c33bbb0-1360-4c37-b38e-3ed6eec5c26e"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "טופל",
                    "value": "72b8ecea-d3b6-4e00-a933-56fcda8094b7"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "דחיה",
                    "value": "91afe1b2-c018-4e90-8a99-c9316a0513e4"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "חדש",
                    "value": "273202a8-382e-445d-93ee-d1e130ad75e1"
                },
                {
                    "disabled": false,
                    "group": null,
                    "selected": false,
                    "text": "ליד עתידי",
                    "value": "ffd999d5-a532-41f6-9b01-fa5de6b34613"
                }
            ]);
            this.setState({
                Statuses: statuses
            })
        }
        if (!model.lastStatusId || model.lastStatusId === "00000000-0000-0000-0000-000000000000") {
            model.lastStatusId = "273202a8-382e-445d-93ee-d1e130ad75e1";
        }
        //console.log(model);
        if (this.props.leadData && this.props.leadData != null) {

        }

        if (!model.involvedAddress) {
            model.involvedAddress = new CustomerAddress();
        }

        if (!model.leadTopType) {
            model.leadTopType = 0;
        }

        if (this.props.leadStore) {
            model.firstName = "";
            model.phoneNumber1 = "";
        }

        if(this.props.phoneNumberForCreateLead && this.props.phoneNumberForCreateLead != '') {
            this.pendingPhoneNumberForCreateLead = this.props.phoneNumberForCreateLead;
            this.props.setPhoneNumberForCreateLead('');
        }
        if(this.pendingPhoneNumberForCreateLead && this.pendingPhoneNumberForCreateLead != '') {
            model.phoneNumber1 = this.pendingPhoneNumberForCreateLead;
        }

        if (model.phoneNumber13) {
            this.setState({ contactNumber: 3 });
        } else if (model.phoneNumber12) {
            this.setState({ contactNumber: 2 });
        }

        this.setState({
            Lead: model,
            leadAdditionsFromRelation: model.leadAdditionsFromRelation,
            LeadTopType: model.leadTopType
        });
        // /^\d$/.exec(
        const licenseNumber = this.props.leadStore && this.props.leadStore.vehicle ? this.props.leadStore.vehicle.licenseNumber : model.vehicle != null ? model.vehicle.licenseNumber : "";
        //     if (model.vehicle != null && model.vehicle.licenseNumber) {
        //     licenseNumber = model.vehicle.licenseNumber;
        // }
        this.setState({ licenseNumber: licenseNumber, treeData: this.props.treeData,loading: false }, () => {
            if (this.props.leadStore && this.props.leadStore.vehicle) {
                if (this.props.leadStore.vehicle.licenseNumber != null && this.props.leadStore.vehicle.licenseNumber != '') {
                    this.setCarDetails(this.props.leadStore.vehicle.licenseNumber);
                } else if (this.props.leadStore.vehicle.modelCode != null && this.props.leadStore.vehicle.modelCode != '') {
                    this.loadModelCode(this.props.leadStore.vehicle.modelCode);
                }
                this.props.setLeadStore(null);
            }
        });

    }

    setCarDetails = async (licenseNumber: any) => {
        this.setState({ licenseNumberLoading: true });
        const lead = this.state.Lead;
        const _vehicle: VehicleDetailsData = new VehicleDetailsData();
        var data = await this.simulatorModel.getVehicleDetailsByLicenseNumber(licenseNumber);
        if (data) {
            //console.log('getVehicleDetails', data);
            if (data.LeviItzhak != null) {

                if (data.LeviItzhak.error != null && data.LeviItzhak.error.code && (data.LeviItzhak.error.code != 0)) {
                    await this.setState({ missingVehicleDetails: true });
                    await this.setState({ showVehicleDetails: true });


                }
                else {
                    await this.setState({ missingVehicleDetails: false });
                    await this.setState({ showVehicleDetails: true });

                }
                if (data.LeviItzhak.manufacturer != null) {
                    _vehicle.manufacturerId = data.LeviItzhak.manufacturer.val
                }
                if (data.LeviItzhak.vehicleModel != null) {
                    _vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val;

                }
                if (data.LeviItzhak.vehicleSubModel != null) {
                    lead.vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;
                    if (!lead.vehicle.vehicleSubModel) {
                        lead.vehicle.vehicleSubModel = new VehicleSubModelModel();
                    }
                    lead.vehicle.vehicleSubModel.modelCode = data.LeviItzhak.vehicleSubModel.code;
                    lead.vehicle.licenseNumber = licenseNumber;
                    lead.vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;

                    _vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;

                }

                lead.vehicle.esp = data.LeviItzhak.esp;
                lead.vehicle.fcw = data.LeviItzhak.fcw;
                lead.vehicle.ldw = data.LeviItzhak.ldw;
                lead.vehicle.carYear = data.LeviItzhak.carYear;


                lead.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
                lead.vehicle.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
                lead.carYear = data.LeviItzhak.carYear;
                lead.entryToRoadDate = data.LeviItzhak.entryToRoad;
                lead.vehicle.entryToRoadDate = data.LeviItzhak.entryToRoad;

                _vehicle.modelCode = data.LeviItzhak.vehicleSubModel ? data.LeviItzhak.vehicleSubModel.code : "";
                _vehicle.tozeretCd = data.LeviItzhak.tozeretCd;
                _vehicle.degemCd = data.LeviItzhak.degemCd;
                _vehicle.carYear = data.LeviItzhak.carYear;

            }

            lead.vehicle.licenseNumber = licenseNumber;
            this.setState({ Lead: lead });
            this.setState({ Vehicle: _vehicle });
            this.checkForDoubleLead('license', licenseNumber, 4)
        } else {
            lead.vehicle.modelCode = '';
            lead.vehicle.vehicleSubModel.modelCode = '';
            this.setState({ Lead: lead });
        }
        this.setState({ licenseNumberLoading: false });

    }

    getModelDataByCode = async (code: string) => {
        let modelData: any = null;
        try {

            modelData = await new SimulatorModel().getModelDetailsByModelCode(code, this.state.licenseNumber);
            if (modelData.manufacturer) {
                //console.log('loadModelCode', code, modelData);
            }
        } catch (error) {

        }
        return modelData;
    }

    loadModelCode = async (search: string) => {
        let lead = this.state.Lead;
        let modelcodeAll: any[] = [];

        if (!lead.vehicle.vehicleSubModel) {
            lead.vehicle.vehicleSubModel = {};
        }
        lead.vehicle.vehicleSubModel.modelCode = search ? search : '';

        lead.vehicle.modelCode = search ? search : '';
        this.setState({
            Lead: lead,
            modelError: false,
            modelCodeNotExists: false
        });
        if (search && search.length >= 3) {
            modelcodeAll = await new SimulatorModel().getModelCode(search);
            const modelcodeAutocomplete = modelcodeAll.filter((item: any) => item.label !== null && item.val !== null);
            this.setState({
                ModelcodeAutocomplete: modelcodeAutocomplete,
                ModelcodeAll: modelcodeAll
            });
        }

        if (search == null || !this.validateModelCode(search)) {
            await this.setState({
                modelError: true
            });
        } else {
            if (this.validateModelCode(search)) {
                this.getModelCodeData(search)
            }
        }
    }

    async getModelCodeData(code: string) {

        if (code && code !== '' && this.state.lastmodelCode != code) {
            this.setState({ modelCodeLoading: true });
            this.setState({ lastmodelCode: code });
            this.clearModelVehicleData();
            const data = await this.getModelDataByCode(code);
            var lead = this.state.Lead;
            if (data) {

                const vehicle: VehicleDetailsData = new VehicleDetailsData();

                if (data.LeviItzhak != null) {
                    vehicle.modelCode = code;

                    lead.vehicle.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
                    if (!lead.vehicle.licenseNumber || lead.vehicle.licenseNumber.length == 0) {
                        lead.vehicle.carYear = data.LeviItzhak.carYear;
                        vehicle.carYear = data.LeviItzhak.carYear;
                        lead.vehicle.entryToRoadDate = data.LeviItzhak.carYear;

                    }

                    if(data.LeviItzhak.carYear){
                        lead.vehicle.carYear = data.LeviItzhak.carYear;
                    }

                    if (lead.vehicle.manufacturer == undefined) {
                        lead.vehicle.manufacturer = new Manufacturer();
                    }


                    if (data.LeviItzhak.manufacturer != null) {
                        lead.vehicle.manufacturerId = data.LeviItzhak.manufacturer.val
                        lead.vehicle.manufacturer.name = data.LeviItzhak.manufacturer.label;
                        vehicle.manufacturerId = data.LeviItzhak.manufacturer.val;

                    }
                    if (data.LeviItzhak.vehicleModel != null) {

                        lead.vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val
                        //lead.vehicle.vehicleModel = data.LeviItzhak.vehicleModel.label;

                        vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val;
                    }
                    if (lead.vehicle.vehicleSubModel == undefined) {
                        lead.vehicle.vehicleSubModel = new VehicleSubModel();
                    }

                    if (data.LeviItzhak.vehicleSubModel != null) {

                        lead.vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val
                        lead.vehicle.vehicleSubModel.name = data.LeviItzhak.vehicleSubModel.label;
                        lead.vehicle.vehicleSubModel.modelCode = data.LeviItzhak.vehicleSubModel.code;
                        lead.vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;

                        vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;

                        vehicle.tozeretCd = data.LeviItzhak.tozeretCd;
                        vehicle.degemCd = data.LeviItzhak.degemCd;



                    }
                    lead.vehicle.esp = data.LeviItzhak.esp;
                    lead.vehicle.fcw = data.LeviItzhak.fcw;
                    lead.vehicle.ldw = data.LeviItzhak.ldw;
                    await this.setState({ Vehicle: vehicle });

                    if (data.LeviItzhak.error != null && data.LeviItzhak.error.code && (data.LeviItzhak.error.code > 0)) {
                        await this.setState({ missingVehicleDetails: true });
                        await this.setState({ showVehicleDetails: true });


                    }
                    else {
                        await this.setState({ missingVehicleDetails: false });
                        await this.setState({ showVehicleDetails: true });
                    }

                }
                lead.vehicle.licenseNumberLoading = false;

            } else {
                this.setState({modelCodeNotExists: true});
            }
            this.setState({ Lead: lead });
        }
        else {
            this.clearModelVehicleData();
        }
        this.setState({ modelCodeLoading: false })
    }


    async buildBranchesSelectData() {
        const branches = await this.getBranchesTree();
        let branchesSelectData: any[] = [];

        branches.forEach((b: any) => {
            const items = this.buildBranchSelectItems(b, '');
            // branchesSelectData = Object.assign(branchesSelectData, items);
            items.forEach(i => {
                branchesSelectData.push(i);
            })
        });
        return this.buildSelectDataObject(branchesSelectData);
    }

    async getBranchesTree() {
        const allBranches = await this.simulatorModel.getBranches();
        const branchesTree = allBranches.filter((b: any) => b.parentId === null);
        branchesTree.forEach((rootBranch: any) => {
            rootBranch.children = this.getSubBranches(rootBranch, allBranches);
        });


        return branchesTree;
    }

    buildBranchSelectItems = (branch: any, branchName: string = '') => {
        if (branchName !== '') {
            branchName += '/';
        }
        branchName += branch.name;
        let items: any[] = [];
        if (branch.users && branch.users.length > 0) {
            branch.users.forEach((user: any) => {
                items.push({
                    value: user.value,
                    text: branchName + '/' + user.text
                })
            })
        }
        if (branch.children && branch.children.length > 0) {
            branch.children.forEach((child: any) => {
                const childItems = this.buildBranchSelectItems(child, branchName);
                if (childItems && childItems.length > 0) {
                    items = Object.assign(items, childItems);
                }
            })
        }

        return items;
    }

    buildSelectDataObject = (dataList: any[]) => {
        return dataList.map((a: any) => {
            return {
                description: a.fullName,
                name: a.text,
                id: a.id
            }
        }) as IDNameDescriptionItem[];
    }

    
    buildSelectDataObjectAgentList = (dataList: any[]) => {
        return dataList.map((a: any) => {
            return {
                description: a.text,
                name: a.text,
                id: a.value
            }
        }) as IDNameDescriptionItem[];
    }
    
    buildSelectDataObjectHandleList = (dataList: any[]) => {
        return dataList.map((a: any) => {
            return {
                description: a.fullName,
                name: a.text,
                id: a.id,
                agentId: a.agentId
            }
        }) as any[];
    }

    getSubBranches = (branch: any, branches: any[]) => {
        const subBranches = branches.filter((b: any) => b.parentId === branch.id);
        if (subBranches && subBranches.length > 0) {
            subBranches.forEach((b: any) => {
                b.children = this.getSubBranches(b, branches);
            })
        }
        return subBranches;
    }


    buildTreeSelectData = async () => {
        const allBranches = await this.simulatorModel.getBranches();
        const rootItems = allBranches.filter((b: any) => b.parentId === null);
        const subBranches = allBranches.filter((b: any) => b.parentId != null);
        const branchesTree: any = [];
        rootItems.forEach((bItem: any) => {
            const branch = this.buildBranchData(bItem.id, allBranches);
            branchesTree.push(branch);
        });

        // this.setState({
        //     Branches: branchesTree
        // });
        return branchesTree;
    }

    buildBranchData = (branchId: string | null, allBranches: any[]) => {
        const branchData = allBranches.find((b: any) => b.id === branchId);
        const branch: any = {
            label: branchData.name,
            value: branchData.id,
            tagClassName: ''
        }
        const subBranches: any[] = [];
        const items = allBranches.filter((b: any) => b.parentId === branchId);
        items.forEach((item: any) => {
            const branchSub = this.buildBranchData(item.id, allBranches);
            subBranches.push(branchSub);
        });
        branch.children = subBranches;
        if (branchData.users && branchData.users.length > 0) {
            branchData.users.forEach((user: any) => {
                branch.children.push({
                    value: user.value,
                    label: user.text
                })
            })
        }
        return branch;
    }

    onTreeSelectChange = (currentNode: any, selectedNodes: any[]) => {
    }


    closePopup = (status?: string) => {
        this.props.ClosePopup(status);
        this.props.setSimulatorData(null);
    }

    closeVehiclePopup = () => {
        this.setState({ "ShowVehiclePopup": false });

    }


    connectVehicle = async (vehicleSubmodelId?: string)=>{
        // 

        if (vehicleSubmodelId) {
            var lead = this.state.Lead;
            lead.vehicle.vehicleSubModelId = vehicleSubmodelId;
            this.setState({ Lead: lead });
            this.setState({ missingVehicleDetails: false });
            //this.setState({showVehicleDetails:false});
            await this.simulatorModel.simulatorUpdateVehicleSubModel(lead.vehicle.licenseNumber, vehicleSubmodelId);
            const generalModel: GeneralDataModel = new GeneralDataModel();
            let data = await generalModel.getVehicleInfoGetVehicleSubModelsById(vehicleSubmodelId);
            lead.vehicleModelId = vehicleSubmodelId;
            lead.vehicle.vehicleSubModel.name = data.name;
            lead.vehicle.vehicleSubModel.id = data.id;
            lead.vehicle.vehicleSubModel.modelCode = data.modelCode;
            lead.vehicle.modelCode = data.modelCode;
            this.closeVehiclePopup();
        }

    }

    saveOfferByLeads = async (leadId: string) => {
        if (leadId && this.props.simulatorData) {
            let data = this.props.simulatorData;
            data.lead = {
                id: leadId,
            }
            await new SimulatorModel().saveSimulator(data);
        }
    }


    upsertLead = async () => {
        await this.setState({
            licenseError: false,
            modelError: false,
            modelCodeNotExists: false,
            addressError: false,
            customerErrors: {
                firstName: false,
                lastName: false,
                firstName2: false,
                lastName2: false,
                firstName3: false,
                lastName3: false,
                phoneNumber1: false,
                phoneNumber2: false,
                phoneNumber12: false,
                phoneNumber22: false,
                phoneNumber13: false,
                phoneNumber23: false,
                email: false,
                identifier: false,
            },
            vehicleErrors: {
                year: false
            },
            signatureError: false,
            policyTypeError: false,
            propertyTypeError: false,
            signatureSelectError: false,
            identifierError: false,
            deliveryDateError: false,
            agentError: false,
            handlerError: false,
        });
        this.setState({ saveLoading: true });

        const lead = this.fixDataBeforeUpsert(this.state.Lead);

        // checks
        let hasErrors = false;
        const licenseNumber = lead.vehicle && lead.vehicle.licenseNumber && lead.vehicle.licenseNumber !== '' ? lead.vehicle.licenseNumber : null;
        const modelCode: string = lead.vehicle && lead.vehicle.vehicleSubModel && lead.vehicle.vehicleSubModel.modelCode && lead.vehicle.vehicleSubModel.modelCode !== '' ? lead.vehicle.vehicleSubModel.modelCode : null;

        const customerErrors = this.state.customerErrors;

        if (!lead.firstName || lead.firstName == '' || !this.validateHebrewInput(lead.firstName)) {
            customerErrors.firstName = true;
            hasErrors = true;
        }
        if (!lead.lastName || lead.lastName == '' || !this.validateHebrewInput(lead.lastName)) {
            customerErrors.lastName = true;
            hasErrors = true;
        }
        if (this.state.contactNumber > 1) {
            if (!lead.firstName2 || lead.firstName2 == '' || !this.validateHebrewInput(lead.firstName2)) {
                customerErrors.firstName2 = true;
                hasErrors = true;
            }
            if (!lead.lastName2 || lead.lastName2 == '' || !this.validateHebrewInput(lead.lastName2)) {
                customerErrors.lastName2 = true;
                hasErrors = true;
            }
        }
        if (this.state.contactNumber === 3) {
            if (!lead.firstName3 || lead.firstName3 == '' || !this.validateHebrewInput(lead.firstName3)) {
                customerErrors.firstName3 = true;
                hasErrors = true;
            }
            if (!lead.lastName3 || lead.lastName3 == '' || !this.validateHebrewInput(lead.lastName3)) {
                customerErrors.lastName3 = true;
                hasErrors = true;
            }
        }

        // remove the space before and after the first name and last name and join them to one name with one space only if firstName or lastName contain two words or more
        if (lead.firstName && lead.firstName != '') {
            lead.firstName = lead.firstName.trim().replace(/\s+/g, ' ');
        }
        if (lead.lastName && lead.lastName != '') {
            lead.lastName = lead.lastName.trim().replace(/\s+/g, ' ');
        }
        if (lead.firstName2 && lead.firstName2 != '') {
            lead.firstName2 = lead.firstName2.trim().replace(/\s+/g, ' ');
        }
        if (lead.lastName2 && lead.lastName2 != '') {
            lead.lastName2 = lead.lastName2.trim().replace(/\s+/g, ' ');
        }
        if (lead.firstName3 && lead.firstName3 != '') {
            lead.firstName3 = lead.firstName3.trim().replace(/\s+/g, ' ');
        }
        if (lead.lastName3 && lead.lastName3 != '') {
            lead.lastName3 = lead.lastName3.trim().replace(/\s+/g, ' ');
        }

        const isMobileValid = await this.checkPhone('phoneNumber1', false)
        if (!isMobileValid) {
            customerErrors.phoneNumber1 = true;
            hasErrors = true;
        }
        if (lead.phoneNumber2 && lead.phoneNumber2 != '') {
            const isPhoneValid2 = await this.checkPhone('phoneNumber2', false);
            if (!isPhoneValid2) {
                customerErrors.phoneNumber2 = true;
                hasErrors = true;
            }
        }

        if (this.state.contactNumber > 1) {
            const isMobileValid12 = await this.checkPhone('phoneNumber12', false)
            if (!isMobileValid12) {
                customerErrors.phoneNumber12 = true;
                hasErrors = true;
            }
            if (lead.phoneNumber22 && lead.phoneNumber22 != '') {
                const isPhoneValid22 = await this.checkPhone('phoneNumber22', false);
                if (!isPhoneValid22) {
                    customerErrors.phoneNumber22 = true;
                    hasErrors = true;
                }
            }
        }

        if (this.state.contactNumber === 3) {
            const isMobileValid13 = await this.checkPhone('phoneNumber13', false)
            if (!isMobileValid13) {
                customerErrors.phoneNumber13 = true;
                hasErrors = true;
            }
            if (lead.phoneNumber23 && lead.phoneNumber23 != '') {
                const isPhoneValid23 = await this.checkPhone('phoneNumber23', false);
                if (!isPhoneValid23) {
                    customerErrors.phoneNumber23 = true;
                    hasErrors = true;
                }
            }
        }

        if (lead.email && lead.email != '' && !this.validateEmail(lead.email)) {
            customerErrors.email = true;
            hasErrors = true;
        }

        if(this.state.missingVehicleDetails) {
            // this.setState({ showVehicleDetails: true });
            hasErrors = true;
        }

        // if(lead.agent == null || lead.agent == ''){
        //     customerErrors.agent = true;
        //     hasErrors = true;
        // }

        console.log('lead.handlerId', lead.handlerId)

        if(lead.handlerId == null || lead.handlerId == '' || lead.handlerId == "0"){
            if(this.state.moreDetailsPermission){
                this.setState({
                    handlerError: true
                });
                hasErrors = true;
            }
        }

        if(lead.agentId == null || lead.agentId == ''){
            this.setState({
                agentError: true
            });
            hasErrors = true;
        }

        await this.setState({ customerErrors: customerErrors });
        switch (this.state.LeadTopType) {
            case 0:
                if (lead.leadType > 0 && licenseNumber == null) {
                    await this.setState({
                        licenseError: true
                    });
                    hasErrors = true;
                }
                if (modelCode == null || !this.validateModelCode(modelCode)) {
                    await this.setState({
                        modelError: true
                    });
                    hasErrors = true;
                }
                if (lead.vehicle && lead.vehicle.carYear == '') {
                    this.setState({
                        vehicleErrors: {
                            year: true
                        }
                    });
                    hasErrors = true;
                }
                if (lead.vehicle && lead.vehicle.vehicleSubModelId == null) {
                    await this.setState({
                        modelError: true,
                        modelCodeNotExists: true
                    });
                    hasErrors = true;
                }
                if (parseInt(lead.id) == 0) {
                    if (!lead.deliveryDate || lead.deliveryDate == undefined) {
                        this.setState({
                            deliveryDateError: true
                        });
                        hasErrors = true;
                    }
                }


                break;
            case 1:
                // if (!lead.involvedAddress.city || !lead.involvedAddress.street || !lead.involvedAddress.street) {
                //     this.setState({ addressError: true });
                //     hasErrors = true;
                // }
                if (lead.propertyType < 0) {
                    this.setState({ propertyTypeError: true });
                    hasErrors = true;
                }
                // propertyTypeError
                lead.vehicle = null;
                break;
            case 2: {
                lead.vehicle = null;
                if (lead.policyType <= 0) {
                    this.setState({ policyTypeError: true });
                    hasErrors = true;
                }
                break;
            }
            default:
                break;
        }

        if (this.props.id == "0") {
            if (!this.state.SignatureCheckbox && !this.state.IgnoreSignature) {
                await this.setState({ signatureSelectError: true });
                hasErrors = true;
            } else {
                if (this.state.SignatureCheckbox) {
                    const signatureUrl = this.canvasRef.current.getTrimmedCanvas().toDataURL("image/png");
                    if (!this.state.initialSignatureUrl || this.state.initialSignatureUrl == signatureUrl) {
                        await this.setState({ signatureError: true });
                        hasErrors = true;
                    }
                }
            }
            // this.state.SignatureCheckbox
        }
        if (!lead.identityType || lead.identityType < 1) {
            lead.identityType = 1;
        }

        if (lead.identityType == 1) {
            if (!lead.identifier || lead.identifier == '') {
                // await this.setState({identifierError: true});
                // hasErrors = true;
            } else {
                const idIsValid = this.validateIdentifier(this.state.Lead.identifier);
                if (!idIsValid) {
                    await this.setState({ identifierError: true });
                    hasErrors = true;
                }
            }
        }


        if (hasErrors) {
            this.setState({ saveLoading: false });
            return;
        }
        // doubleLead
        if (this.state.doubleLeadWarning.license || this.state.doubleLeadWarning.mobile) {
            lead.doubleLead = true;
        }

        const res = await new LeadsModel().upsertLead(lead);
        if (res) {

            // this.state.SourceLead = lead;
            await this.setState({ SourceLead: lead });
        }
        if (res.code && res.code == "200") {
            if (this.props.simulatorData) {
                this.saveOfferByLeads(res.val);

                const lastFilterStr = localStorage.getItem('lastLeadsFilter');
                let savedFilter: any = {};
                if (lastFilterStr && lastFilterStr !== '{}') {
                    
                    savedFilter = JSON.parse(lastFilterStr);
                    // savedFilter.searchText = ownerCustomer.firstName + " " + ownerCustomer.lastName;
                    savedFilter.searchText = lead.firstName + " " + lead.lastName;
                    savedFilter.createDateFrom = null;

                    localStorage.setItem('lastLeadsFilter', JSON.stringify(savedFilter));
                }
            }
            console.log('upsertLead callerTreatment-out', this.props.callerTreatment);

            if(this.props.callerTreatment){
                console.log('upsertLead callerTreatment', this.props.callerTreatment);
                let treatment = { ...this.props.callerTreatment };
                treatment.LeadRelatedId = res.val;
                let result =  await new CustomerCardModel().treatmentsUpsertTreatment(treatment);
                console.log('upsertLead result', result);
                if(result ){
                    this.props.setCallerTreatment({treatment:null});
                    //remove the treatment from localStorage List treatmentQueue
                    const treatmentQueue = localStorage.getItem('treatmentQueue');
                    if(treatmentQueue && treatmentQueue != ''){
                        let treatmentQueueList = JSON.parse(treatmentQueue);
                        treatmentQueueList = treatmentQueueList.filter((t: any) => t.id != treatment.id);
                        localStorage.setItem('treatmentQueue', JSON.stringify(treatmentQueueList));
                    }
                }
            }
            this.closePopup('success');
        }
        this.setState({ saveLoading: false });
        this.closePopup();
        if (this.props.simulatorData) {
            this.props.setSimulatorData(null);
        }
    }

    checkPhone = async (type: string, updateState: boolean = true) => {
        let isValid = true;
        const lead = this.state.Lead;
        const customerErrors = this.state.customerErrors;
        switch (type) {
            case 'phoneNumber1':
                if (!lead.phoneNumber1 || lead.phoneNumber1 == '' || lead.phoneNumber1.length < 10 || !this.validateIsraelPhoneNumber(lead.phoneNumber1)) {
                    customerErrors.phoneNumber1 = true;
                    isValid = false;
                }
                break;
            case 'phoneNumber2':

                if (lead.phoneNumber2 && lead.phoneNumber2 != '' && ((lead.phoneNumber2.length < 9) || !this.validateIsraelPhoneNumber(lead.phoneNumber2))) {
                    customerErrors.phoneNumber2 = true;
                    isValid = false;
                }
                break;


            case 'phoneNumber12':
                if (!lead.phoneNumber12 || lead.phoneNumber12 == '' || lead.phoneNumber12.length < 10 || !this.validateIsraelPhoneNumber(lead.phoneNumber12)) {
                    customerErrors.phoneNumber12 = true;
                    isValid = false;
                }
                break;
            case 'phoneNumber22':

                if (lead.phoneNumber22 && lead.phoneNumber22 != '' && ((lead.phoneNumber22.length < 9) || !this.validateIsraelPhoneNumber(lead.phoneNumber22))) {
                    customerErrors.phoneNumber22 = true;
                    isValid = false;
                }
                break;


            case 'phoneNumber13':
                if (!lead.phoneNumber13 || lead.phoneNumber13 == '' || lead.phoneNumber13.length < 10 || !this.validateIsraelPhoneNumber(lead.phoneNumber13)) {
                    customerErrors.phoneNumber13 = true;
                    isValid = false;
                }
                break;
            case 'phoneNumber23':

                if (lead.phoneNumber23 && lead.phoneNumber23 != '' && ((lead.phoneNumber23.length < 9) || !this.validateIsraelPhoneNumber(lead.phoneNumber23))) {
                    customerErrors.phoneNumber23 = true;
                    isValid = false;
                }
                break;

            default:
                break;
        }
        if (updateState) {
            await this.setState({ customerErrors: customerErrors });
        }
        return isValid
    }

    validateIsraelPhoneNumber = (phoneNumber: string): boolean => {
        // Regular expression for Israel phone numbers
        const israelPhoneNumberRegex = /^(0\d{1,2})-?(\d{3})-?(\d{4})$/;
        // Remove any non-digit characters from the phone number
        const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
        // Check if the cleaned phone number matches the Israel phone number regex
        return israelPhoneNumberRegex.test(cleanedPhoneNumber);
    }

    validateEmail = (email: string): boolean => {
        // Regular expression for basic email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    validateModelCode = (modelCode: string): boolean => {
        const regex = /^(?:[1-3]\d{6}|[0-9]{5,6})$/;
        return regex.test(modelCode);
    }

    checkIdentifier = (id: string) => {
        id.replace(/\D{9}/g, '');
    }

    validateIdentifier(id: string) {
        var lead = this.state.Lead;
        if (lead.identityType == 1) {
            return this.isValidIsraeliId(id)
            // return /^\d{9}$/.test(id);
        } else {
            return /^\d$/.test(id);
        }
    };

    isValidIsraeliId(id: string): boolean {
        // Check if the input is a string and has 9 digits
        if (!/^\d{9}$/.test(id)) return false;

        // Convert the ID number to an array of digits
        const digits = id.split('').map(Number);

        // Calculate the sum of the digits
        let sum = 0;
        for (let i = 0; i < 8; i++) {
            let digit = digits[i];
            if (i % 2 === 0) {
                // For even indices, multiply the digit by 1
                sum += digit;
            } else {
                // For odd indices, multiply the digit by 2 and add the digits of the result
                sum += Math.floor(digit * 2 / 10) + (digit * 2) % 10;
            }
        }

        // The ninth digit (check digit)
        const checkDigit = digits[8];

        // Validate the check digit
        return (sum + checkDigit) % 10 === 0;
    }

    validateHebrewInput(userInput: string) {
        var hebrewRegex = /^[\u0590-\u05FF\s]+$/; // Range for Hebrew characters including spaces
        return hebrewRegex.test(userInput);
    }

    async openVehiclePopup() {
        if (localStorage.getItem("isAdminUser") == "true") {
            await this.setState({ ShowVehiclePopup: true });
        }

    }

    fixDataBeforeUpsert = (sourceLead: any) => {
        sourceLead.startDate = this.checkDate(sourceLead.startDate);
        sourceLead.endDate = this.checkDate(sourceLead.endDate);
        sourceLead.createdDate = this.checkDate(sourceLead.createdDate);
        sourceLead.identityCardIssueDate = sourceLead.identityCardIssueDate ? this.checkDate(sourceLead.identityCardIssueDate) : undefined;
        sourceLead.simulatorOfferStageDate = this.checkDate(sourceLead.simulatorOfferStageDate);
        sourceLead.updatedDate = this.checkDate(sourceLead.updatedDate, true);
        sourceLead.deliveryDate = sourceLead.deliveryDate ? this.checkDate(sourceLead.deliveryDate) : undefined;
        if (sourceLead.lastStatus) {
            sourceLead.lastStatus.updatedDate = this.checkDate(sourceLead.lastStatus.updatedDate);
        }
        if (sourceLead.vehicle) {
            sourceLead.vehicle.entryToRoadDate = this.checkDate(sourceLead.vehicle.entryToRoadDate);
        }
        if (sourceLead.offers && sourceLead.offers.length > 0) {
            sourceLead.offers.forEach((offer: any) => {
                if (offer.vehicle) {
                    offer.vehicle.entryToRoadDate = this.checkDate(offer.vehicle.entryToRoadDate)
                }
            });
        }
        // sourceLead.addLeadAdditions = sourceLead.LeadAdditions;

        // const lead = new LeadModel();
        if (this.props.id == '0' && this.state.SignatureCheckbox) {
            const signature = this.getSignature();
            sourceLead.signature = signature;
        }
        if (this.state.LeadTopType) {
            sourceLead.leadTopType = this.state.LeadTopType;
        }
        if (sourceLead) {
            delete sourceLead.agent;
            delete sourceLead.loginUser;
            delete sourceLead.agents;
            delete sourceLead.branches;
            delete sourceLead.handler;
            delete sourceLead.leadAdditionsFromRelation;
            delete sourceLead.salesPeople;
            delete sourceLead.statuses;
            delete sourceLead.users;
            delete sourceLead.creator;
            delete sourceLead.stationUser;
            if (sourceLead.vehicle) {
                Object.keys(sourceLead.vehicle).forEach((key: string) => {
                    switch (key) {
                        case 'vehicleSubModelId':
                        case 'licenseNumber':
                        case 'modelCode':
                        case 'carYear':
                        case 'entryToRoadDate':
                        case 'carLicenseFilePath':
                            break;
                        default:
                            //delete sourceLead.vehicle[key];
                            break;
                    }
                    // if (key != 'id' && key != 'vehicleSubModelId' && key != 'licenseNumber') { //modelCode
                    //     delete sourceLead.vehicle[key];
                    // }
                })
            }

        }
        return sourceLead;
    }

    checkDate = (date: any, newDate?: boolean) => {
        if (this.props.id != "0") {
            if (newDate) {
                return new Date();
            }
            // return new Date('1974-01-01') > new Date(date) ? date : new Date();
        }
        return new Date('1974-01-01') < new Date(date) ? date : null;
    }

    setLeadType = (leadType: number) => {
        var lead = this.state.Lead;
        if (lead != null) {
            lead.leadType = leadType;
            if (this.props.id == "0") {
                const licenseNumber = lead.vehicle.licenseNumber;
                const modelCode = lead.vehicle.vehicleSubModel ? lead.vehicle.vehicleSubModel.modelCode : undefined;
                if (!modelCode || modelCode == '')
                    switch (leadType) {
                        case 0:
                            lead.vehicle.carYear = this.state.CarYear[1]
                            break;

                        default:
                            lead.vehicle.carYear = '';
                            break;
                    }
            }
            this.setState({ Lead: lead });
        }
    }

    setLeadTopType = (leadTopType: number) => {
        this.setState({
            LeadTopType: leadTopType
        });

        const lead = this.state.Lead;
        switch (leadTopType) {
            case 0:
                if (this.props.id == "0") {
                    lead.deliveryDate = undefined;
                }
                break;
            case 2:
                if (this.props.id == "0") {
                    lead.deliveryDate = undefined;
                }
                // 
                break;
            case 1:
                if (this.props.id == "0") {
                    lead.deliveryDate = undefined;
                }
                if (!lead.involvedAddress) {
                    lead.involvedAddress = new CustomerAddress();
                }
                break;
            default:
                break;
        }
        this.setState({
            Lead: lead
        });
    }

    setCheckboxStateData = (name: string, event: any) => {
        const data = this.state.Lead;
        data[name] = event.currentTarget.checked;
        this.setState({ Lead: data });

    }

    setLeadStateInputData = (name: string, event: any) => {
        const lead = this.state.Lead;
        let value = event.currentTarget.value;
        const customerErrors = this.state.customerErrors;
        switch (name) {
            case 'phoneNumber1':
                const doubleLeadWarning = this.state.doubleLeadWarning;
                doubleLeadWarning.mobile = false;
                customerErrors[name] = false;
                this.setState(
                    {
                        customerErrors,
                        doubleLeadWarning
                    }
                );
                value = value.replace(/\D/g, '');
                if (this.validateIsraelPhoneNumber(value)) {
                    this.checkForDoubleLead('mobile', value, 1);
                }
                break;
            case 'phoneNumber12':
                const doubleLeadWarning1 = this.state.doubleLeadWarning1;
                doubleLeadWarning1.mobile = false;
                customerErrors[name] = false;
                this.setState(
                    {
                        customerErrors,
                        doubleLeadWarning1
                    }
                );
                value = value.replace(/\D/g, '');
                if (this.validateIsraelPhoneNumber(value)) {
                    this.checkForDoubleLead('mobile', value, 2);
                }
                break;
            case 'phoneNumber13':
                const doubleLeadWarning2 = this.state.doubleLeadWarning2;
                doubleLeadWarning2.mobile = false;
                customerErrors[name] = false;
                this.setState(
                    {
                        customerErrors,
                        doubleLeadWarning2
                    }
                );
                value = value.replace(/\D/g, '');
                if (this.validateIsraelPhoneNumber(value)) {
                    this.checkForDoubleLead('mobile', value, 3);
                }
                break;
            case 'phoneNumber2':
                value = value.replace(/\D/g, '');
                customerErrors[name] = false;
                this.setState(customerErrors);
                break;

            case 'phoneNumber22':
                value = value.replace(/\D/g, '');
                customerErrors[name] = false;
                this.setState(customerErrors);
                break;

            case 'phoneNumber23':
                value = value.replace(/\D/g, '');
                customerErrors[name] = false;
                this.setState(customerErrors);
                break;

            case 'firstName':
            case 'firstName2':
            case 'firstName3':
                customerErrors[name] = false;
                this.setState(customerErrors);
                // value = value.replace(/^[\u0590-\u05FF\s]+$/,'');
                value = value.replace(/[^\u0590-\u05FF \-\u05F3\u05F4']/g, '');
                break;

            case 'lastName':
            case 'lastName2':
            case 'lastName3':
                customerErrors[name] = false;
                this.setState(customerErrors);
                // value = value.replace(/^[\u0590-\u05FF\s]+$/,'');
                value = value.replace(/[^\u0590-\u05FF \-\u05F3\u05F4']/g, '');
                break;

            default:
                break;
        }
        lead[name] = value;
        this.setState({ Lead: lead });
    }

    checkForDoubleLead = async (type: string, value: string, typeOfWarrning: number) => {
        switch (type) {
            case 'mobile':
                const d1 = await new LeadsModel().checkPhoneForDoubleLead(value);
                if (d1 && d1.doubleLead) {
                    const doubleLeadWarning = typeOfWarrning === 1 ? this.state.doubleLeadWarning : typeOfWarrning === 2 ? this.state.doubleLeadWarning1 : this.state.doubleLeadWarning2;
                    doubleLeadWarning.mobile = true;
                    if (typeOfWarrning === 1) {
                        this.setState({ doubleLeadWarning: doubleLeadWarning })
                    } else if (typeOfWarrning === 2) {
                        this.setState({ doubleLeadWarning1: doubleLeadWarning })
                    } else if (typeOfWarrning === 3) {
                        this.setState({ doubleLeadWarning2: doubleLeadWarning })
                    }
                }
                break;
            case 'license':
                const d2 = await new LeadsModel().checkLicenseFoDoubleLead(value);
                if (d2 && d2.leads) {
                    const doubleLeadWarning = this.state.doubleLeadWarning;
                    doubleLeadWarning.license = true;
                    this.setState({ doubleLeadWarning })
                }
                break;

            default:
                break;
        }
    }

    onIgnoreSignatureClick = async (e: any) => {
        const value = e.target.checked;
        this.clearSignature();
        await this.setState({
            IgnoreSignature: value,
            SignatureCheckbox: false
        });
    }

    onSignatureCheckboxClick = async (e: any) => {
        const value = e.target.checked;
        await this.setState({
            IgnoreSignature: false,
            SignatureCheckbox: value
        });
        this.clearSignature();
    }

    onLeadParamChange = async (name: string, event: any) => {
        const data = this.state.Lead;
        const newValue = event.currentTarget.value;
        if (data != null) {
            data[name] = newValue;
            switch (name) {
                case 'identifier':
                    const warnings = this.state.warnings;
                    warnings.idIsExists = false;
                    this.setState({ identifierError: false });
                    if (data.identityType == 1) {
                        const idIsValid = this.validateIdentifier(newValue);
                        if (!idIsValid) {
                            await this.setState({ identifierError: true });
                        } else {
                            const customerDetails: any = await this.simulatorModel.getCustomerDetailsById(newValue);
                            if (customerDetails && customerDetails.customer) {
                                // const lead = this.state.Lead;
                                data.firstName = customerDetails.customer.firstName;
                                data.lastName = customerDetails.customer.lastName;
                                // idIsExists
                                warnings.idIsExists = true;
                                this.setState({ warnings });
                            }
                        }
                    }
                    this.setState({ warnings });
                    data[name] = data[name].replace(/\D/g, '');
                    break;

                default:
                    break;
            }
            this.setState({ Lead: data });
        }
    }

    setLeadStateVehicleInputData = (name: string, event: any) => {
        const lead = this.state.Lead;
        var vehicle = lead.vehicle;
        vehicle[name] = event.currentTarget.value;
        lead.vehicle = vehicle;
        this.setState({ Lead: lead });
    }

    formatDate(dateString: string): Date {
        // Extract year, month, and day from the string
        const day = parseInt(dateString.slice(0, 2), 10);
        const month = parseInt(dateString.slice(2, 4), 10) - 1; // Month is zero-based in JavaScript Date
        const year = parseInt(dateString.slice(4, 8), 10);
        // Create a Date object
        const date = new Date(year, month, day);
        return date;
    }

    formatDateToValid(date: Date) {
        //console.log('formatDateToValid', moment(date).format('DDMMYYYY'));
    }



    setStateData = (name: string, value: any) => {
        const data = this.state.Lead;
        data[name] = value;
        switch (name) {
            case 'deliveryDate':
                this.setState({ deliveryDateError: false });
                this.formatDateToValid(value as Date)
                break;
            case 'identityCardIssueDate': {

                break;
            }
            case 'agentId':{
                this.setState({ agentError: false });
                console.log('agentId value', value)
                console.log('this.state.CustomerHandlers', this.state.CustomerHandlersList)
                const agents = Array.isArray(this.state.CustomerHandlersList) ? this.state.CustomerHandlersList.filter((a: any) => a.agentId == value ||  a.agentId == 0) : [];
                console.log('agents', agents)
                this.setState({ CustomerHandlers: agents });
                data['handlerId'] = "0"
                // data.agent = agent;
                break;

            }
            case 'handlerId': {
                this.setState({ handlerError: false });
                break;
            }



            default:
                break;
        }
        this.setState({ Lead: data });


    }

    setStateVehicleData = (name: string, value: any) => {
        const data = this.state.Lead;
        var vehicle = data.vehicle;
        vehicle[name] = value;
        data.vehicle = vehicle;
        this.setState({ Lead: data });

    }

    getVehicleDetails2 = async (licenseNumber: string) => {
        const data = this.state.Lead;
        var vehicle = data.vehicle;
        vehicle.licenseNumber = licenseNumber;
        const _vehicle: VehicleDetailsData = new VehicleDetailsData();


        var vehicleData = await new SimulatorModel().getVehicleDetailsByLicenseNumber(licenseNumber);
        if (vehicleData != null) {

            if (vehicleData.LeviItzhak != null) {

                if (vehicleData.LeviItzhak.error != null && data.LeviItzhak.error.code && (data.LeviItzhak.error.code == 542 || data.LeviItzhak.error.code == 543)) {
                    await this.setState({ missingVehicleDetails: true });
                    await this.setState({ showVehicleDetails: true });


                }
                else {
                    await this.setState({ missingVehicleDetails: false });
                    await this.setState({ showVehicleDetails: true });

                }



                if (vehicleData.LeviItzhak.manufacturer != null) {
                    vehicle.manufacturerId = vehicleData.LeviItzhak.manufacturer.val;
                    vehicle.manufacturer = vehicleData.LeviItzhak.manufacturer.label
                    _vehicle.manufacturerId = vehicleData.LeviItzhak.manufacturer.val
                }
                if (vehicleData.LeviItzhak.vehicleModel != null) {
                    vehicle.vehicleModelId = vehicleData.LeviItzhak.vehicleModel.val;
                    vehicle.vehicleModel = vehicleData.LeviItzhak.vehicleModel.label;
                    _vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val;
                }

                if (vehicleData.LeviItzhak.vehicleSubModel != null) {
                    vehicle.vehicleSubModelId = vehicleData.LeviItzhak.vehicleSubModel.val;
                    vehicle.vehicleSubModel = vehicleData.LeviItzhak.vehicleSubModel;
                    vehicle.modelCode = vehicleData.LeviItzhak.vehicleSubModel.code;

                    vehicle.entryToRoadDate = vehicleData.LeviItzhak.vehicleSubModel.entryToRoad;

                    _vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;

                }
                vehicle.esp = vehicleData.LeviItzhak.esp;
                vehicle.fcw = vehicleData.LeviItzhak.fcw;
                vehicle.ldw = vehicleData.LeviItzhak.ldw;

                vehicle.vehicleOwnership = vehicleData.LeviItzhak.vehicleOwnership;
                vehicle.carYear = vehicleData.LeviItzhak.carYear;
                vehicle.entryToRoadDate = vehicleData.LeviItzhak.entryToRoad;

                _vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;
                _vehicle.tozeretCd = data.LeviItzhak.tozeretCd;
                _vehicle.degemCd = data.LeviItzhak.degemCd;
                _vehicle.carYear = vehicleData.LeviItzhak.carYear;


            }
        }
        data.vehicle = vehicle;
        this.setState({ Lead: data });
        this.setState({ vehicle: _vehicle });
    }


    getSelectedAdditions = () => {
        const data = this.state.Lead;
        const leadAdditionsFromRelation = this.state.leadAdditionsFromRelation;
        if (!leadAdditionsFromRelation) {
            return;
        }
        let result = [];
        var additionsAll = data.leadAdditionsFromRelation;
        var selectedAddiotions = data.leadAdditions.map(
            (item: LeadAdditionRelationModel) => item.leadAdditionId
        );

        result = additionsAll.filter((x: LeadAdditionModel) => (selectedAddiotions.indexOf(x.id) != -1));

        return result.map((i: any) => {
            return {
                Text: i.name,
                Value: i.id
            }
        });
    }

    addLeadAdditions = (value: string) => {
        if (this.state.Lead != null && this.state.Lead != null) {
            const lead = this.state.Lead;
            var leadAdditions = lead.leadAdditions;
            if (leadAdditions == null) {
                leadAdditions = [];
            }

            leadAdditions.push(new LeadAdditionRelationModel({ leadAdditionId: value }));
            lead.leadAdditions = leadAdditions;
            this.setState({ Lead: lead });
        }
    }

    removeLeadAdditions = (value: string) => {
        if (this.state.Lead != null && this.state.Lead.lead != null) {
            const lead = this.state.Lead;
            var leadAdditions = lead.LeadAdditions;
            leadAdditions = leadAdditions.filter(function (item: LeadAdditionRelationModel) {
                return item.leadAdditionId != value;
            });
            lead.LeadAdditions = leadAdditions;
            this.setState({ Lead: lead });
        }
    }

    getVehicleDetailsKeyPress = async (event: any) => {
        const licenseNumber = /^\d$/.exec(event.target.value)
        if (event.key === 'Enter') {
            // this.getVehicleDetails(event);
        } else {
            this.setState({ licenseNumber: licenseNumber });
        }
    }

    onVehicleNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let licenseNumberValue = "";
        console.log('onVehicleNumberChange', event.target.value)
        // if(event.target.value.length > 1){
        //     console.log('trim')
        // }
        licenseNumberValue = event.target.value.trim();

        console.log('onVehicleNumberChange trim', licenseNumberValue)
        

        const licenseNumber = licenseNumberValue

        console.log('onVehicleNumberChange licenseNumber', licenseNumber)

        const doubleLeadWarning = this.state.doubleLeadWarning;
        doubleLeadWarning.license = false;

        this.setState({
            licenseNumber: licenseNumber,
            doubleLeadWarning
        });
        const lead = this.state.Lead;
        lead.vehicle.licenseNumber = licenseNumber;
        lead.vehicle.modelCode = '';
        if (lead.vehicle.vehicleSubModel != null) {
            lead.vehicle.vehicleSubModel.modelCode = '';
        }
        if (lead.leadType == 0) {
            lead.vehicle.carYear = new Date().getMonth() == 11 && new Date().getDate() >= 15 ? parseInt(this.state.CarYear[1]) : parseInt(this.state.CarYear[2]);
        } else {
            lead.vehicle.carYear = '';
        }
        this.setState({ Lead: lead });
    }

    clearVehicleData = async () => {
        const leadData = this.state.Lead;
        leadData.modelCode = "";
        leadData.automaticInd = false;
        leadData.carYear = new Date().getFullYear();
        leadData.entryToRoadDate = null;
        leadData.manufacturer = "";
        leadData.vehicleModel = "";
        leadData.vehicleSubModel = "";
        leadData.manufacturerId = null;
        leadData.vehicleModelId = null;
        leadData.vehicleSubModelId = null;
        leadData.esp = false;
        leadData.fcw = false;
        leadData.ldw = false;
        const vehicleData = this.state.Vehicle;
        if (vehicleData != null) {
            vehicleData.manufacturerId = "";
            vehicleData.vehicleModelId = "";
            vehicleData.vehicleSubModelId = "";
            vehicleData.modelCode = "";
            vehicleData.tozeretCd = undefined;
            vehicleData.degemCd = undefined;
        }



        await this.setState({ Lead: leadData });
        await this.setState({ Vehicle: vehicleData });
    }

    clearModelVehicleData = async () => {

        const leadData = this.state.Lead;
        leadData.automaticInd = true;
        leadData.carYear = new Date().getFullYear();
        leadData.entryToRoadDate = null;
        leadData.manufacturer = "";
        leadData.vehicleModel = "";
        leadData.vehicleSubModel = "";
        leadData.manufacturerId = null;
        leadData.vehicleModelId = null;
        leadData.vehicleSubModelId = null;
        leadData.esp = false;
        leadData.fcw = false;
        leadData.ldw = false;
        const vehicleData = this.state.Vehicle;
        if (vehicleData != null) {
            vehicleData.manufacturerId = "";
            vehicleData.vehicleModelId = "";
            vehicleData.vehicleSubModelId = "";
            vehicleData.modelCode = "";
            vehicleData.tozeretCd = undefined;
            vehicleData.degemCd = undefined;
        }



        await this.setState({ Lead: leadData });
        await this.setState({ Vehicle: vehicleData });
    }


    getVehicleDetails = async (event: any) => {
        var licenseNumber = event.currentTarget.value;

        this.clearVehicleData();

        if (licenseNumber.length > 0 && this.state.lastLicense != licenseNumber.length) {
            this.setState({ lastLicense: licenseNumber });

            this.setState({ licenseNumberLoading: true });
            const lead = this.state.Lead;
            const _vehicle: VehicleDetailsData = new VehicleDetailsData();
            var data = await this.simulatorModel.getVehicleDetailsByLicenseNumber(licenseNumber);
            if (data) {
                if (data.LeviItzhak != null) {

                    if (data.LeviItzhak.error != null && data.LeviItzhak.error.code && (data.LeviItzhak.error.code != 0)) {
                        await this.setState({ missingVehicleDetails: true });
                        await this.setState({ showVehicleDetails: true });


                    }
                    else {
                        await this.setState({ missingVehicleDetails: false });
                        await this.setState({ showVehicleDetails: true });

                    }
                    if (data.LeviItzhak.manufacturer != null) {
                        _vehicle.manufacturerId = data.LeviItzhak.manufacturer.val
                    }
                    if (data.LeviItzhak.vehicleModel != null) {
                        _vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val;

                    }
                    if (data.LeviItzhak.vehicleSubModel != null) {
                        lead.vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;
                        if (!lead.vehicle.vehicleSubModel) {
                            lead.vehicle.vehicleSubModel = new VehicleSubModelModel();
                        }
                        lead.vehicle.vehicleSubModel.modelCode = data.LeviItzhak.vehicleSubModel.code;
                        lead.vehicle.licenseNumber = licenseNumber;
                        lead.vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;

                        _vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;

                    }

                    lead.vehicle.esp = data.LeviItzhak.esp;
                    lead.vehicle.fcw = data.LeviItzhak.fcw;
                    lead.vehicle.ldw = data.LeviItzhak.ldw;
                    lead.vehicle.carYear = data.LeviItzhak.carYear;


                    lead.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
                    lead.vehicle.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
                    lead.carYear = data.LeviItzhak.carYear;
                    lead.entryToRoadDate = data.LeviItzhak.entryToRoad;
                    lead.vehicle.entryToRoadDate = data.LeviItzhak.entryToRoad;

                    _vehicle.modelCode = data.LeviItzhak.vehicleSubModel ? data.LeviItzhak.vehicleSubModel.code : "";
                    _vehicle.tozeretCd = data.LeviItzhak.tozeretCd;
                    _vehicle.degemCd = data.LeviItzhak.degemCd;
                    _vehicle.carYear = data.LeviItzhak.carYear;

                }



                lead.vehicle.licenseNumber = licenseNumber;
                this.setState({ Lead: lead });
                this.setState({ Vehicle: _vehicle });
                this.checkForDoubleLead('license', licenseNumber, 4)
            } else {
                lead.vehicle.modelCode = '';
                lead.vehicle.vehicleSubModel.modelCode = '';
                this.setState({ Lead: lead });
            }
            this.setState({ licenseNumberLoading: false });
        }

    }

    selectModelCode = async (id: string) => {
        if (!id) {
            return;
        }
        this.setState({ modelCodeLoading: true });
        const data = await new SimulatorModel().getVehicleDetails(id);
        console.log('selectModelCode-data', data)
        debugger;


        // const data = await new SimulatorModel().getModelCode(id);

        const modelCodes: any[] = this.state.ModelcodeAutocomplete as any[];
        const modelCode = modelCodes.find(model => model.value == id);

        if (modelCode) {
            const code = modelCode.text.split(' - ')[0];
            const modelData = await this.getModelDataByCode(code);
            console.log('selectModelCode-modelData', modelData)
            debugger;
            if (modelData) {
                this.setState({ Lead: lead });
                if (modelData.LeviItzhak.error != null && modelData.LeviItzhak.error.code && (modelData.LeviItzhak.error.code != 0)) { }
                if (modelData.LeviItzhak) {
                    var _vehicle: VehicleDetailsData = new VehicleDetailsData();
                    _vehicle.modelCode = code;
                    if (modelData.LeviItzhak.manufacturer)
                        _vehicle.manufacturerId = modelData.LeviItzhak.manufacturer.val;
                    if (modelData.LeviItzhak.vehicleModel)
                        _vehicle.vehicleModelId = modelData.LeviItzhak.vehicleModel.val;
                    if (modelData.LeviItzhak.vehicleSubModel)
                        _vehicle.vehicleSubModelId = modelData.LeviItzhak.vehicleSubModel.val;
                    _vehicle.tozeretCd = modelData.LeviItzhak.tozeretCd;
                    _vehicle.degemCd = modelData.LeviItzhak.degemCd;
                    await this.setState({ Vehicle: _vehicle });
                }

                await this.setState({ missingVehicleDetails: false });
                await this.setState({ showVehicleDetails: true });
            }
        }

        var lead = this.state.Lead;
        var vehicle = lead.vehicle;
        vehicle.manufacturerId = data.manufacturer.val;

        if (vehicle.manufacturer == undefined) {
            vehicle.manufacturer = new Manufacturer();
        }
        if (data.manufacturer && data.manufacturer.label) {
            vehicle.manufacturer.name = data.manufacturer.label;
        }

        if (data.vehicleModel) {
            vehicle.vehicleModelId = data.vehicleModel.val;
        }
        //vehicle.vehicleModel.name = data.vehicleModel.label;
        if (vehicle.vehicleSubModel == undefined) {
            vehicle.vehicleSubModel = new VehicleSubModel();
        }

        if (data.vehicleSubModel) {
            vehicle.vehicleSubModelId = data.vehicleSubModel.val;
            vehicle.vehicleSubModel.name = data.vehicleSubModel.label;
            vehicle.vehicleSubModel.modelCode = data.vehicleSubModel.code;
            vehicle.modelCode = data.vehicleSubModel.code;
        }

        if(data.carYear){
            vehicle.carYear = data.carYear;
        }
        lead.vehicle = vehicle;
        this.setState({ Lead: lead, modelCodeLoading: false });
    }

    onModelCodeBlur = async () => {
        return;
        const code = this.state.Lead.vehicle.vehicleSubModel.modelCode;

        if (code && code !== '') {
            this.setState({ modelCodeLoading: true })
            const data = await this.getModelDataByCode(code);
            var lead = this.state.Lead;
            if (data) {
                if (this.state.Lead.vehicle.vehicleSubModel.modelCode == code) {
                    lead.vehicle.vehicleSubModel.modelCode = code;
                    if (data.vehicleSubModel) {
                        lead.vehicle.vehicleSubModelId = data.vehicleSubModel.val;

                        if (lead.vehicle.vehicleSubModel == undefined) {
                            lead.vehicle.vehicleSubModel = new VehicleSubModel();
                        }
                        lead.vehicle.vehicleSubModel.name = data.vehicleSubModel.label;
                    }
                    lead.vehicle.esp = data.esp;
                    lead.vehicle.fcw = data.fcw;
                    lead.vehicle.ldw = data.ldw;
                }
                if (data.manufacturer == null) {
                    lead.vehicle.vehicleSubModelId = null
                    await this.setState({
                        modelError: true,
                        modelCodeNotExists: true
                    });
                }

            } else {
            }
            this.setState({ Lead: lead });
        }
        this.setState({ modelCodeLoading: false })
    }

    onModelCodeFocus = async () => {
        await this.setState({
            modelError: false
        });
    }

    setCarLicenseFile = (event: any) => {
        const fileUploaded = event.target.files[0];
        const fileSize: string = ((fileUploaded.size / 1024) / 1024).toFixed(4);
        if (parseFloat(fileSize) > 5) {
            return;
        }
        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            reader.onloadend = () => {
                const lead = this.state.Lead;
                const fileName = (new Date().getTime()) + "_" + fileUploaded.name;
                lead.carLicenseFile = {
                    FileName: fileName,
                    Content: reader.result
                };
                const carLicenseFile: any = {
                    fileName: fileName,
                    url: null
                }
                this.setState({
                    Lead: lead,
                    carLicenseFile: carLicenseFile
                });
            }
            reader.readAsDataURL(fileUploaded);
        }
    };


    removeLicenceFile() {
        const lead = this.state.Lead;
        lead.carLicenseFile = null;
        this.setState({ Lead: lead, carLicenseFile: null });
    }

    setComment = (name: string, event: any) => {
        const data = this.state.Lead;
        if (data != null) {
            data.comment = event.currentTarget.value;
            this.setState({ Lead: data });
        }
    }

    onAddressChange = (address: CustomerAddress) => {
        const lead = this.state.Lead;
        lead.involvedAddress = address;
        this.setState({ Lead: lead });
    }


    async clearSignature() {
        this.canvasRef.current.clear();
        await this.setState({
            initialSignatureUrl: this.canvasRef.current.getTrimmedCanvas().toDataURL("image/png")
        })
    }

    getSignature() {
        return this.canvasRef.current.getTrimmedCanvas().toDataURL("image/png")
    }

    onSelect(value: any, node: any) {
    };

    onChange(newValue: string) {
        const data = this.state.Lead;
        data['stationUserId'] = newValue;
        this.setState({ Lead: data });

    };

    onChangeBrunche(newValue: string) {
        const data = this.state.Lead;
        data['referrerId'] = newValue;
        this.setState({ Lead: data });
    }

    async onLeadAdditionsChange(newValues: string[]) {

        if (this.state.Lead != null && this.state.Lead != null) {
            const lead = this.state.Lead;
            
            const leadAdditions = lead.leadAdditions ? lead.leadAdditions : [];
            const newLeadAdditions: any = [];

            newValues.forEach((value: string) => {
                const existLeadAddition = leadAdditions.find((la: any) => la.leadAdditionId == value);
                if (existLeadAddition) {
                    newLeadAdditions.push(existLeadAddition);
                } else {
                    newLeadAdditions.push(new LeadAdditionRelationModel({ leadAdditionId: value }));
                }
            })
            lead.leadAdditions = newLeadAdditions;
            await this.setState({ Lead: lead });

        }
    };

    addContact = () => {
        let number = this.state.contactNumber;
        if (number <= 2) {
            number += 1;
            this.setState({ contactNumber: number });
        }
    }

    subContact = (index: number) => {
        const lead = this.state.Lead;
        let numberOfContact = this.state.contactNumber;
        if (numberOfContact > 1) {
            if (numberOfContact > index) {
                lead.firstName2 = lead.firstName3;
                lead.lastName2 = lead.lastName3;
                lead.phoneNumber12 = lead.phoneNumber13;
                lead.phoneNumber22 = lead.phoneNumber23;
                lead.firstName3 = null;
                lead.lastName3 = null;
                lead.phoneNumber13 = null;
                lead.phoneNumber23 = null;
            } else if (index == 2) {
                lead.firstName2 = null;
                lead.lastName2 = null;
                lead.phoneNumber12 = null;
                lead.phoneNumber22 = null;
            } else if (index == 3) {
                lead.firstName3 = null;
                lead.lastName3 = null;
                lead.phoneNumber13 = null;
                lead.phoneNumber23 = null;
            }
            numberOfContact -= 1;
            this.setState({ contactNumber: numberOfContact, Lead: lead });
        }
    }

    isDisabled = () => {
        const loggedUser = localStorage.getItem('loggedUser');
        if (loggedUser) {
            const user = JSON.parse(loggedUser);
            if (user) {
                if(user.role != 0){
                    return true;
                }
            }
        }
        return false;
    }

    isRefDisabled = () => {
        const loggedUser = localStorage.getItem('loggedUser');
        if (loggedUser) {
            const user = JSON.parse(loggedUser);
            if (user) {
                if([13, 14, 15, 16].includes(user.role)){
                    return true;
                }
            }
        }
        return false;
    }


    handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        this.setState({ isDragging: true, offset: { x: e.clientX - this.state.position.x, y: e.clientY - this.state.position.y } });
    };

    handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        if (this.state.isDragging) {
            this.setState({ position: { x: e.clientX - this.state.offset.x, y: e.clientY - this.state.offset.y } });
        }
    };

    handleMouseUp = (): void => {
        this.setState({ isDragging: false });
    };

    render() {
        return (<>
            {!this.state.loading && this.state.Lead != null && this.state.Lead != null ? (
                <div className="popup-wrapper">
                    <section className="new-lead rtl"
                    style={{ position: 'absolute', top: window.innerWidth < 1050 ? 'auto' :  this.state.position.y, left: window.innerWidth < 1050 ? 'auto' :  this.state.position.x }}>

                        <div className="close-icon pointer" onClick={(e: any) => this.closePopup()}></div>
                        <div className="popup-content">
                            <div className="popup-header"
                                style={{ cursor: this.state.isDragging ? 'grabbing' : 'grab', }}
                                        onMouseDown={this.handleMouseDown}
                                        onMouseMove={this.handleMouseMove}
                                        onMouseUp={this.handleMouseUp}
                                        onMouseLeave={this.handleMouseUp} // Prevent dragging if the mouse leaves the modal
                                        >
                                <div className="popup-title"> {
                                    this.props.id == "0" || this.props.id == null ? 'הוסף ליד חדש' : (`עדכון ליד`)
                                }
                                </div>
                            </div>
                            <div className='header-content-mobile'>
                                <div className="popup-title"> {
                                    this.props.id == "0" || this.props.id == null ? 'הוסף ליד חדש' : (`עדכון ליד`)
                                }
                                </div>
                                {/* <div className="close-icon pointer" onClick={(e: any) => this.closePopup()}></div> */}

                            </div>
                            <div className="popup-body">
                                <div className="top-row">
                                    <div className={`tabs-row LeadTopType_${this.state.LeadTopType}`}>
                                        <div className={this.state.LeadTopType == 0 ? "tab selected" : "tab"} onClick={(e: any) => this.setLeadTopType(0)} data-tab="tab-content-1">
                                            רכב
                                        </div>
                                        <div className={this.state.LeadTopType == 1 ? "tab selected" : "tab"} onClick={(e: any) => this.setLeadTopType(1)} data-tab="tab-content-2">
                                            דירה/עסק
                                        </div>
                                        <div className={this.state.LeadTopType == 2 ? "tab selected" : "tab"} onClick={(e: any) => this.setLeadTopType(2)} data-tab="tab-content-3">
                                            אחר
                                        </div>
                                    </div>
                                </div>



                                <div className="top-row" style={{justifyContent: this.state.LeadTopType == 0 ? 'space-between' : 'end'}}>
                                    <div className={this.state.LeadTopType == 0 ? "tabs-row" : "hide"}>
                                        <div className={this.state.Lead.leadType == 0 ? "tab selected" : "tab"} onClick={(e: any) => this.setLeadType(0)} data-tab="tab-content-1">
                                            חדש
                                        </div>
                                        <div className={this.state.Lead.leadType == 1 ? "tab selected" : "tab"} onClick={(e: any) => this.setLeadType(1)} data-tab="tab-content-2">
                                            סלקט
                                        </div>
                                        <div className={this.state.Lead.leadType == 2 ? "tab selected" : "tab"} onClick={(e: any) => this.setLeadType(2)} data-tab="tab-content-3">
                                            משומש
                                        </div>
                                    </div>
                                    <div className="actions">
                                        <button className="button white blue-border add-new-contact" onClick={() => this.addContact()}>
                                            <div className="icon add"></div>
                                            <div className="title">
                                                הוסף איש קשר
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                {this.state.Lead != null && this.state.Lead.leadType != null ? (
                                    <div className="tab-contents">
                                        <div className="tab-content tab-content-1 selected">
                                            <div className="parameter-row">
                                                <div className={`parameter-item ${this.state.customerErrors.firstName ? 'error' : ''}`}>
                                                    <div className="field">
                                                        <div className="title">
                                                            שם פרטי
                                                        </div>
                                                        <div className="value">
                                                            <input type="text" onChange={(e: any) => this.setLeadStateInputData("firstName", e)} value={this.state.Lead.firstName} />
                                                        </div>
                                                        <div className='error-message'>
                                                            *{this.state.errors.requiredField}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`parameter-item ${this.state.customerErrors.lastName ? 'error' : ''}`}>
                                                    <div className="field">
                                                        <div className="title">
                                                            שם משפחה
                                                        </div>
                                                        <div className="value">
                                                            <input type="text" onChange={(e: any) => this.setLeadStateInputData("lastName", e)} value={this.state.Lead.lastName} />
                                                        </div>
                                                        <div className='error-message'>
                                                            *{this.state.errors.requiredField}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`parameter-item ${this.state.customerErrors.phoneNumber1 ? 'error' : ''}`}>
                                                    <div className="field">
                                                        <div className="title">
                                                            טלפון נייד
                                                        </div>
                                                        <div className="value">
                                                            <input type="text" onBlur={() => this.checkPhone('mobile')} maxLength={10} onChange={(e: any) => this.setLeadStateInputData("phoneNumber1", e)} value={this.state.Lead.phoneNumber1} />
                                                        </div>
                                                        <div className='error-message'>
                                                            {
                                                                !this.state.Lead.phoneNumber1 || this.state.Lead.phoneNumber1 == '' ?
                                                                    (<>
                                                                        *{this.state.errors.requiredField}
                                                                    </>) :
                                                                    (<>
                                                                        *{this.state.errors.invalidMobilePhoneNumber}
                                                                    </>)
                                                            }
                                                        </div>
                                                        <div className={`${this.state.doubleLeadWarning.mobile ? 'warning-message' : 'hide'}`}>
                                                            *{this.state.errors.doubleLeadWarning}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`parameter-item ${this.state.customerErrors.phoneNumber2 ? 'error' : ''}`}>
                                                    <div className="field">
                                                        <div className="title">
                                                            טלפון נוסף
                                                        </div>
                                                        <div className="value">
                                                            <input type="text" onBlur={() => this.checkPhone('phone')} maxLength={10} onChange={(e: any) => this.setLeadStateInputData("phoneNumber2", e)} value={this.state.Lead.phoneNumber2} />
                                                        </div>
                                                        <div className='error-message'>
                                                            *{this.state.errors.invalidPhoneNumber}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.contactNumber >= 2 || this.state.Lead.phoneNumber12 != null ?
                                                <AddContactDetails
                                                    firstName={this.state.Lead.firstName2}
                                                    lastName={this.state.Lead.lastName2}
                                                    phoneNumber1={this.state.Lead.phoneNumber12}
                                                    phoneNumber2={this.state.Lead.phoneNumber22}
                                                    setLeadStateInputData={this.setLeadStateInputData}
                                                    checkPhone={this.checkPhone}
                                                    customerErrors={this.state.customerErrors}
                                                    errors={this.state.errors}
                                                    number={2}
                                                    doubleLeadWarning={this.state.doubleLeadWarning1}
                                                    subContact={this.subContact}
                                                />
                                                : <></>}

                                            {this.state.contactNumber > 2 || this.state.Lead.phoneNumber13 != null ?
                                                <AddContactDetails
                                                    firstName={this.state.Lead.firstName3}
                                                    lastName={this.state.Lead.lastName3}
                                                    phoneNumber1={this.state.Lead.phoneNumber13}
                                                    phoneNumber2={this.state.Lead.phoneNumber23}
                                                    setLeadStateInputData={this.setLeadStateInputData}
                                                    checkPhone={this.checkPhone}
                                                    customerErrors={this.state.customerErrors}
                                                    errors={this.state.errors}
                                                    number={3}
                                                    doubleLeadWarning={this.state.doubleLeadWarning2}
                                                    subContact={this.subContact}
                                                />
                                                : <></>}

                                            <div className={this.state.LeadTopType == 0 ? "vehicleDetails" : "hide"}>




                                                <div className="tab-content-title">
                                                    פרטי רכב
                                                </div>
                                                <div className="parameter-row">
                                                    <div className={`parameter-item ${this.state.licenseError ? 'error' : ''}`}>
                                                        <div className="field">
                                                            <div className="title">
                                                                מספר רכב
                                                            </div>
                                                            <div className="value">
                                                                <input type="text"
                                                                    onBlur={(e: any) => this.getVehicleDetails(e)}
                                                                    value={this.state.Lead.vehicle ? this.state.Lead.vehicle.licenseNumber : null}
                                                                    onKeyDown={(e: any) => this.getVehicleDetailsKeyPress(e)}
                                                                    onChange={(e: any) => this.onVehicleNumberChange(e)}
                                                                    disabled={this.props.simulatorData != null}
                                                                />
                                
                                                                <img src={require("../assets/images/loading.gif")} className={this.state != null && this.state.licenseNumberLoading ? "loadingGif" : "hide"} />
                                                            </div>
                                                            {this.state.Lead.whatsappCarNum && this.state.Lead.whatsappCarNum.length > 0 ? <div className="whatsapp-car-number">
                                                               <div className="title">
                                                                מספר רישוי לאימות
                                                            </div>
                                                               <div className="value">
                                                                {this.state.Lead.whatsappCarNum}
                                                            </div>
                                                                
                                                                
                                                                
                                                                
                                                                </div>
                                                                
                                                                :""}
                                                            <div className='error-message'>
                                                                *{this.state.errors.requiredField}
                                                            </div>
                                                            <div className={`${this.state.doubleLeadWarning.license ? 'warning-message' : 'hide'}`}>
                                                                *{this.state.errors.doubleLeadWarning}
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className={`parameter-item ${this.state.modelError ? 'error' : ''}`}>
                                                        <div className="field">
                                                            <div className="title">
                                                                קוד דגם
                                                            </div>
                                                            <div className="value">
                                                                <Autocomplete Value={this.state.Lead != null && this.state.Lead.vehicle != null && this.state.Lead.vehicle.vehicleSubModel != null ? this.state.Lead.vehicle.vehicleSubModel.modelCode : ""} Id="modelCode"
                                                                    ClassName=''
                                                                    OnChange={(s: string) => this.loadModelCode(s)}
                                                                    OnSelect={this.selectModelCode}
                                                                    OnBlur={() => this.onModelCodeBlur()}
                                                                    OnFocus={this.onModelCodeFocus}
                                                                    DataList={this.state.ModelcodeAutocomplete}
                                                                    simulatorData={this.props.simulatorData}
                                                                />
                                                                <img src={require("../assets/images/loading.gif")} className={this.state != null && this.state.modelCodeLoading ? "loadingGif" : "hide"} />
                                                            </div>
                                                            <div className='error-message'>
                                                                {
                                                                    this.state.modelCodeNotExists ? (
                                                                        <>
                                                                            *{this.state.errors.modelCodeNotExists}
                                                                        </>
                                                                    ) :
                                                                        (
                                                                            <>
                                                                                *{this.state.errors.requiredField}
                                                                            </>
                                                                        )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`parameter-item ${this.state.vehicleErrors.year ? 'error' : ''}`}>
                                                        <div className="field">
                                                            <div className="title">
                                                                שנה
                                                            </div>
                                                            <div className="value">
                                                                <DynamicSelect ClassName="" OnChange={this.setStateVehicleData} Value={this.state.Lead.vehicle != null ? this.state.Lead.vehicle.carYear : ""} Options={this.state.CarYear != null ? this.state.CarYear.map((x: string) => ({ Text: x, Value: x })) : []} Id={"carYear"} simulatorData={this.props.simulatorData} />
                                                            </div>
                                                            <div className='error-message'>
                                                                *{this.state.errors.requiredField}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="parameter-item">
                                                        <div className="field">
                                                            <div className="title">
                                                                מיגון
                                                            </div>
                                                            <div className="value">
                                                                <Select
                                                                    mode="multiple"
                                                                    variant="borderless"
                                                                    allowClear
                                                                    style={{ width: '100%' }}
                                                                    placeholder="נא לבחור מיגון"
                                                                    defaultValue={this.state.Lead.leadAdditions ? this.state.Lead.leadAdditions.map((la: any) => la.leadAdditionId) : ''}
                                                                    onChange={(v: string[]) => this.onLeadAdditionsChange(v)}
                                                                    options={this.state.Lead != null &&
                                                                        this.state.leadAdditionsFromRelation != null ? this.state.leadAdditionsFromRelation.map(
                                                                            (item: LeadAdditionModel) => ({ label: item.name, value: item.id })) : []}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`parameter-item ${this.state.deliveryDateError ? 'error' : ''}`}>
                                                        <div className="field">
                                                            <div className="title">
                                                                תחילת ביטוח/ת. מסירה
                                                            </div>
                                                            <div className="value">
                                                                <CompDatePicker value={this.state.Lead.deliveryDate ? this.state.Lead.deliveryDate : null} onChange={(date: Date) => this.setStateData('deliveryDate', date)} />
                                                                {/* <DatePicker
                                                        ref={this.deliveryDateRef}
                                                        selected={this.state.Lead.deliveryDate}
                                                        onSelect={(e:any) => this.setStateData("deliveryDate", e)}
                                                        onChange={(e:any) => this.setStateData("deliveryDate", e)}
                                                        dateFormat='dd/MM/yyyy'
                                                    /> */}
                                                                {/* <div className="icon small-icon calendar pointer"></div> */}
                                                            </div>
                                                            <div className='error-message'>
                                                                *{this.state.errors.requiredField}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className={"parameter-row"} >
                                                    <div className='parameter-item'>
                                                        <div onClick={(e: any) => this.openVehiclePopup()} className={this.state.showVehicleDetails ? (this.state.missingVehicleDetails ? "editRed" : "edit") : "hide"}>
                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                            <div className={this.state.missingVehicleDetails ? "" : "hide"}>לא נמצאו פרטי רכב

                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>

                                            <div className={this.state.LeadTopType == 1 ? "apartmentDetails" : "hide"}>
                                                <div className="tab-content-title">
                                                    פרטי נכס
                                                </div>
                                                <div className="parameter-row">
                                                    <div className={`parameter-item ${this.state.propertyTypeError ? 'error' : ''}`}>
                                                        <div className="field">
                                                            <div className="title">
                                                                סוג נכס
                                                            </div>
                                                            <div className="value">
                                                                {this.state.PropertyType ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"propertyType"}

                                                                    Options={this.state.PropertyType} Value={this.state.Lead.propertyType != null ? this.state.Lead.propertyType : null} />
                                                                ) : ""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`parameter-item `}>
                                                        <div className="field">
                                                            <div className="title">
                                                                ת. תחילה
                                                            </div>
                                                            <div className="value">
                                                                <CompDatePicker value={this.state.Lead.deliveryDate ? this.state.Lead.deliveryDate : null} onChange={(date: Date) => this.setStateData('deliveryDate', date)} />
                                                                {/* <DatePicker
                                                        ref={this.deliveryDateRef}
                                                        selected={this.state.Lead.deliveryDate}
                                                        onSelect={(e:any) => this.setStateData("deliveryDate", e)}
                                                        onChange={(e:any) => this.setStateData("deliveryDate", e)}
                                                        dateFormat='dd/MM/yyyy'
                                                    /> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`parameter-item `}>
                                                    </div>
                                                    <div className={`parameter-item `}>
                                                    </div>
                                                </div>
                                                <div className={this.state.LeadTopType == 1 ? "" : "hide"}>
                                                    <Address CustomerAddress={this.state.Lead.involvedAddress} addressError={this.state.addressError} addressChange={(data: any) => {
                                                        this.onAddressChange(data)
                                                    }} />
                                                    {/* {this.state.Lead.involvedAddress!=null ? (
                                        ) : ""} */}
                                                </div>

                                            </div>
                                            <div>
                                                <div className="parameter-row single-item">
                                                    <div className="parameter-item">
                                                        <div className="field">
                                                            <div className="title">
                                                                {this.state.LeadTopType != 0 ?
                                                                    <>
                                                                        מסמכים
                                                                    </> : <>
                                                                        צילום רשיון רכב
                                                                    </>
                                                                }
                                                            </div>
                                                            <div className="value">
                                                                {this.state.carLicenseFile && this.state.carLicenseFile && this.state.carLicenseFile.fileName !== '' ? (
                                                                    <div className={`attached-file-row`}>
                                                                        <div>
                                                                            {this.state.carLicenseFile.url ? (
                                                                                <a href={`${this.state.apiUrl}${this.state.carLicenseFile.url}`} target='_blank'>{this.state.carLicenseFile.fileName}</a>
                                                                            ) : (
                                                                                <>{this.state.carLicenseFile.fileName}</>
                                                                            )}
                                                                        </div>
                                                                        <div className="icon trash-brown pointer" onClick={() => this.removeLicenceFile()}></div>
                                                                    </div>
                                                                ) :
                                                                    (
                                                                        <input type="file" accept="image/png, image/gif, image/jpeg, application/pdf" ref={this.hiddenFileInput} onChange={this.setCarLicenseFile} />
                                                                    )}
                                                                {/* <div className="icon small-icon paperclip pointer"></div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={this.state.LeadTopType == 2 ? "otherDetails" : "hide"}>
                                                <div className="parameter-row">
                                                    <div className={`parameter-item ${this.state.policyTypeError ? 'error' : ''}`}>
                                                        <div className="field">
                                                            <div className="title">
                                                                סוג ביטוח
                                                            </div>
                                                            <div className="value">
                                                                {this.state.policyTypes ? (
                                                                    <IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"policyType"}
                                                                        Options={this.state.policyTypes} Value={this.state.Lead.policyType != null ? this.state.Lead.policyType : null} />
                                                                ) : ""}
                                                            </div>
                                                        </div>
                                                        <div >

                                                        </div>
                                                    </div>
                                                    <div className={`parameter-item`}>
                                                        <div className="field">
                                                            <div className="title">
                                                                ת. תחילה
                                                            </div>
                                                            <div className="value">
                                                                <CompDatePicker value={this.state.Lead.deliveryDate ? this.state.Lead.deliveryDate : null} onChange={(date: Date) => this.setStateData('deliveryDate', date)} />
                                                                {/* <DatePicker
                                                            ref={this.deliveryDateRef}
                                                            selected={this.state.Lead.deliveryDate}
                                                            onSelect={(e:any) => this.setStateData("deliveryDate", e)}
                                                            onChange={(e:any) => this.setStateData("deliveryDate", e)}
                                                            dateFormat='dd/MM/yyyy'
                                                        /> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`parameter-item `}>
                                                    </div>
                                                    <div className={`parameter-item `}>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-row single-item">
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            הערות
                                                        </div>
                                                        <div className="value">
                                                            <textarea onChange={(e: any) => this.setComment("comments", e)} value={this.state.Lead != null && this.state.Lead.comment != null ? this.state.Lead.comment : ""}></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                {this.state.moreDetailsPermission ? (
                                                    <>
                                                        <div className="tab-content-title">
                                                            פרטים נוספים



                                                        </div>
                                                        <div className="parameter-row">
                                                            <div className="parameter-item">
                                                                <div className="field">
                                                                    <div className="title">
                                                                        סוג זיהוי
                                                                    </div>
                                                                    <div className="value">
                                                                        {this.state.IdentityTypes ? (
                                                                            <IDNameDescriptionItemSelect
                                                                                OnChange={this.setStateData}
                                                                                Id={"identityType"}
                                                                                Options={this.state.IdentityTypes}
                                                                                Value={this.state.Lead != null ? this.state.Lead.identityType : null}
                                                                            />
                                                                        ) : ""}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={`parameter-item ${this.state.identifierError ? 'error' : ''}`}>
                                                                <div className="field">
                                                                    <div className="title">
                                                                        ת.ז/דרכון
                                                                    </div>
                                                                    <div className="value">
                                                                        <input type="text"
                                                                            maxLength={9}
                                                                            value={this.state.Lead != null ? this.state.Lead.identifier : ""}
                                                                            onChange={(e) => this.onLeadParamChange('identifier', e)}
                                                                        />
                                                                    </div>
                                                                    <div className='error-message'>
                                                                        {this.state.Lead && (!this.state.Lead.identifier || this.state.Lead.identifier == '') ? (
                                                                            <>
                                                                                *{this.state.errors.requiredField}
                                                                            </>
                                                                        ) :
                                                                            (
                                                                                <>
                                                                                    {this.state.Lead.identityType == 1 && this.state.Lead.identifier.length < 9 ? (
                                                                                        <>
                                                                                            *{this.state.errors.reguiredIdNineNumbers}
                                                                                        </>
                                                                                    ) :
                                                                                        (
                                                                                            <>
                                                                                                *{this.state.errors.invalidId}
                                                                                            </>
                                                                                        )}
                                                                                </>
                                                                            )}
                                                                    </div>
                                                                    <div className={`${this.state.warnings.idIsExists ? 'warning-message' : 'hide'}`}>
                                                                        *{this.state.errors.idIsExists}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={`parameter-item ${this.state.customerErrors.email ? 'error' : ''}`}>
                                                                <div className="field">
                                                                    <div className="title">
                                                                        אימייל
                                                                    </div>
                                                                    <div className="value">
                                                                        <input type="text"
                                                                            value={this.state.Lead != null ? this.state.Lead.email : ""}
                                                                            onChange={(e) => this.onLeadParamChange('email', e)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="parameter-item">
                                                                <div className="field">
                                                                    <div className="title">
                                                                        תאריך הנפקת ת.ז
                                                                    </div>
                                                                    <div className="value">
                                                                        <CompDatePicker value={this.state.Lead.identityCardIssueDate ? this.state.Lead.identityCardIssueDate : null} onChange={(date: Date) => this.setStateData('identityCardIssueDate', date)} />
                                                                        {/* <DatePicker
                                                        ref={this.identifierDateRef}
                                                        selected={this.state.Lead!=null ? this.state.Lead.identityCardIssueDate:null}
                                                        onSelect={(e:any) => this.setStateData("identityCardIssueDate", e)}
                                                        onChange={(e:any) =>  this.setStateData("identityCardIssueDate", e)}
                                                        dateFormat='dd/MM/yyyy'
                                                    />
                                                    <div className="icon small-icon calendar pointer"></div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="parameter-row">

                                                            <div className="parameter-item">
                                                                <div className="field">
                                                                    <div className="title">
                                                                        עמדה
                                                                    </div>
                                                                    <div className="value">
                                                                        {this.state.treeData || this.props.treeData ? (
                                                                            <TreeSelect
                                                                                variant="borderless"
                                                                                treeLine
                                                                                placeholder='עמדה'
                                                                                showSearch
                                                                                style={{
                                                                                    width: '100%',
                                                                                }}
                                                                                dropdownStyle={{
                                                                                    maxHeight: 400,
                                                                                    overflow: 'auto',
                                                                                }}
                                                                                allowClear
                                                                                onChange={(v) => this.onChange(v)}
                                                                                treeData={this.props.treeData}
                                                                                value={this.state.Lead != null ? this.state.Lead.stationUserId : null}
                                                                                disabled={this.isDisabled()}
                                                                            />

                                                                        ) : ""}
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className="parameter-item">
                                                                <div className="field">
                                                                    <div className="title">
                                                                        מפנה
                                                                    </div>
                                                                    <div className="value">
                                                                        {this.props.treeDataBrunches ? (
                                                                            <TreeSelect
                                                                                variant="borderless"
                                                                                treeLine
                                                                                placeholder='מפנה'
                                                                                showSearch
                                                                                style={{
                                                                                    width: '100%',
                                                                                }}
                                                                                dropdownStyle={{
                                                                                    maxHeight: 400,
                                                                                    overflow: 'auto',
                                                                                }}
                                                                                allowClear
                                                                                onChange={(v) => this.onChangeBrunche(v)}
                                                                                treeData={this.props.treeDataBrunches}
                                                                                value={this.state.Lead != null ? this.state.Lead.referrerId : null}
                                                                                disabled={this.isRefDisabled()}
                                                                            />

                                                                        ) : ""}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className={`parameter-item ${this.state.agentError ? 'error' : ''}`}>
                                                                <div className="field">
                                                                    <div className="title">
                                                                        סוכן
                                                                    </div>
                                                                    <div className="value">
                                                                            {/* <input type="text" />
                                                                        <div className="icon small-icon select-arrow pointer"></div> */}

                                                                        {this.state.CustomerAgents ? (
                                                                            <IDNameDescriptionItemSelect
                                                                                OnChange={this.setStateData}
                                                                                Id={"agentId"}
                                                                                Value={this.state.Lead != null ? this.state.Lead.agentId : null}
                                                                                Options={this.state.CustomerAgents
                                                                                }
                                                                            />
                                                                        ) : ""}
                                                                    </div>
                                                                    <div className='error-message'>
                                                                        *{this.state.errors.requiredField}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className={`parameter-item ${this.state.handlerError ? 'error' : ''}`}>
                                                                <div className="field">
                                                                    <div className="title">
                                                                        מטפל
                                                                    </div>
                                                                    <div className="value">
                                                                        {this.state.CustomerHandlers ? (
                                                                            <IDNameDescriptionItemSelect
                                                                                OnChange={this.setStateData}
                                                                                Id={"handlerId"}

                                                                                Value={this.state.Lead != null ? this.state.Lead.handlerId : null}
                                                                                Options={this.state.CustomerHandlers}
                                                                            />
                                                                        ) : ""}
                                                                        {/* Disabled={!(this.state.isAdmin)}*/}


                                                                    </div>
                                                                    <div className='error-message'>
                                                                        *{this.state.errors.requiredField}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="parameter-item">
                                                                <div className="field">
                                                                    <div className="title">
                                                                        סטטוס
                                                                    </div>
                                                                    <div className="value">
                                                                        {
                                                                            this.state.Statuses ? (
                                                                                // lastStatusId
                                                                                <IDNameDescriptionItemSelect
                                                                                    OnChange={this.setStateData}
                                                                                    Id={"lastStatusId"}
                                                                                    Options={this.state.Statuses}
                                                                                    Value={this.state.Lead != null ? this.state.Lead.lastStatusId : null}
                                                                                />
                                                                            ) : ""
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="parameter-row">
                                                            <div className="parameter-item"></div>
                                                            <div className="parameter-item"></div>
                                                        </div>
                                                        <div className="parameter-row single-item">
                                                            <div className="parameter-item">
                                                                <div className="field">
                                                                    <div className="title">
                                                                        הערה פנימית
                                                                    </div>
                                                                    <div className="value">
                                                                        <textarea onChange={(e: any) => this.setLeadStateInputData("internalComment", e)} value={this.state.Lead != null && this.state.Lead.internalComment != null ? this.state.Lead.internalComment : ""}>

                                                                        </textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>) : <></>
                                                }
                                                {this.props.id == '0' || this.props.id == null ? (<>
                                                    <div className="parameter-row">
                                                        <div className={`parameter-item signature-checkbox ${this.state.signatureSelectError ? 'error' : ''}`}>
                                                            <input type={'checkbox'} onChange={(e: any) => this.onIgnoreSignatureClick(e)} value={this.state.Lead != null && this.state.Lead.IgnoreSignature != null ? this.state.Lead.IgnoreSignature : ""} checked={this.state.IgnoreSignature}></input>
                                                            <span> הודעתי ללקוח כי יצרו איתו קשר לקבלת הצעה לביטוח והלקוח הסכים</span>
                                                        </div>
                                                        <div className="parameter-item"></div>
                                                    </div>
                                                    <div className="parameter-row">
                                                        <div className={`parameter-item signature-checkbox ${this.state.signatureSelectError ? 'error' : ''}`}>
                                                            <input type={'checkbox'} onChange={(e: any) => this.onSignatureCheckboxClick(e)} value={this.state.Lead != null && this.state.Lead.SignatureCheckbox != null ? this.state.Lead.SignatureCheckbox : ""} checked={this.state.SignatureCheckbox}></input>
                                                            <span>קראתי ואני מאשר את התקנון ואת  <a href="https://www.8099.co.il/%d7%9e%d7%93%d7%99%d7%a0%d7%99%d7%95%d7%aa-%d7%a0%d7%97-%d7%91%d7%99%d7%98%d7%95%d7%97-%d7%91%d7%a0%d7%95%d7%a9%d7%90-%d7%a9%d7%9e%d7%99%d7%a8%d7%aa-%d7%94%d7%a4%d7%a8%d7%98%d7%99%d7%95%d7%aa%d7%90/" target="_blank">הצהרת הפרטיות</a></span>
                                                        </div>
                                                        <div className="parameter-item"></div>
                                                    </div>

                                                    <div className={`signature-wrapper ${this.state.signatureError ? 'error' : ''}${this.state.SignatureCheckbox ? '' : ' hide'}`} style={{ background: 'white' }}>
                                                        <SignaturePad
                                                            ref={this.canvasRef}
                                                            canvasProps={{
                                                                width: 960,
                                                                height: 200,
                                                                className: "signatureCanvas"
                                                            }}
                                                        />
                                                        <button onClick={(e: any) => this.clearSignature()}>Clear</button>
                                                    </div>
                                                </>) : (<>
                                                </>)}



                                            </div>
                                        </div>
                                    </div>
                                ) : ""}
                            </div>
                            <div className="popup-footer">
                                <button className="button white blue-border" onClick={(e: any) => this.closePopup()}>
                                    ביטול
                                </button>
                                <button className="button blue" onClick={(e: any) => this.upsertLead()}  disabled={this.state.saveLoading ? true : false}>
                                   {this.props.id == "0" || this.props.id == null ?' הוסף ליד'  :' עדכן ליד'}
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            ) :  ""}

            {
               this.state.loading && (
                    <PleaseWaitLayer />
                )
            }
            


            <div className={this.state.ShowVehiclePopup ? "" : "hide"}>
                <VehicleDetails manufacturerId={this.state.Vehicle && this.state.Vehicle.manufacturerId ? this.state.Vehicle.manufacturerId : ""} vehicleModelId={this.state.Vehicle && this.state.Vehicle.vehicleModelId ? this.state.Vehicle.vehicleModelId : ""}
                    vehicleSubModelId={this.state.Vehicle && this.state.Vehicle.vehicleSubModelId ? this.state.Vehicle.vehicleSubModelId : ""}
                    modelCode={this.state.Vehicle && this.state.Vehicle.modelCode ? this.state.Vehicle.modelCode : ""}
                    ClosePopup={() => this.closeVehiclePopup()}
                    tozeretCd={this.state.Vehicle ? this.state.Vehicle.tozeretCd : undefined}
                    degemCd={this.state.Vehicle ? this.state.Vehicle.degemCd : undefined}
                    GetVehicleSubmodelId={this.connectVehicle}
                    year={this.state.Vehicle && this.state.Vehicle.carYear ? this.state.Vehicle.carYear : 0}
                ></VehicleDetails>
            </div>
        </>



        );
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setLeadStore: (obj: any | null) => dispatch(setLeadStore(obj)),
        setSimulatorData: (obj: any | null) => dispatch(setSimulatorData(obj)),
        dispatch,
        setPhoneNumberForCreateLead: (phoneNumber: string) => dispatch(setPhoneNumberForCreateLead({ phoneNumber })),
        setCallerTreatment: (treatment: any) => dispatch(setCallerTreatment({ treatment })),
    }
}

const mapStateToProps = (state: RootState) => ({
    leadStore: state.policyProduction.leadStore,
    simulatorData: state.policyProduction.simulatorData,
    phoneNumberForCreateLead: state.call.phoneNumberForCreateLead,
    callerTreatment: state.call.callerTreatment,
});

export default connect(mapStateToProps, mapDispatchToProps)(LeadPopup);